{
    "AccountStatus": {
        "id": "number",
        "accounts": "Account[]",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "Address": {
        "id": "number",
        "address_1": "string",
        "address_2": "string",
        "addressables": "Addressable[]",
        "categories": "Category",
        "city": "string",
        "country": "Country",
        "country_id": "number",
        "is_archived": "boolean",
        "latitude": "number",
        "longitude": "number",
        "state": "State",
        "state_id": "number",
        "subdivision": "string",
        "zip": "string",
        "_nullable": [
            "address_2",
            "state_id",
            "zip",
            "country_id",
            "subdivision",
            "latitude",
            "longitude"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "address_1",
            "address_2",
            "city",
            "state_id",
            "zip",
            "country_id",
            "subdivision",
            "is_archived"
        ],
        "_unique": []
    },
    "Addressable": {
        "id": "number",
        "address": "Address",
        "address_id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "owner": "Addressable",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "f_id",
            "f_type",
            "address_id"
        ],
        "_unique": []
    },
    "ArtistAlias": {
        "id": "number",
        "artist": "Artist",
        "artist_id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "artist_id",
            "name",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "artist_id"
        ],
        "_unique": [
            "name"
        ]
    },
    "AudioFileIssue": {
        "id": "number",
        "details": "any[]",
        "issue_type": "'GvlibraryMissing' | 'GvlibrarySizeMismatch' | 'GvlibraryUnreadable' | 'OriginalMissing' | 'OriginalUnreadable' | 'VbrDetected' | 'BitrateMismatch' | 'LowBitrate' | 'HlsMasterMissing' | 'HlsVariantMissing' | 'HlsChunkCountMismatch' | 'HlsMasterUnplayable' | 'HlsUnreadable' | 'Mp3valError' | 'Mp3valWarning' | 'Mp3valNotRun' | 'NormalizationMetadataMissing'",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "severity": "'Error' | 'Warning' | 'Info'",
        "verified_at": "Date",
        "_nullable": [
            "details"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "AudioFileStates": {
        "id": "number",
        "last_pass_a_rerun_at": "Date",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "_nullable": [
            "last_pass_a_rerun_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "AudioFileVerificationState": {
        "id": "number",
        "gvlibrary_bitrate_kbps": "number",
        "is_vbr": "boolean",
        "last_file_updated_at": "Date",
        "last_verified_at": "Date",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "original_bitrate_kbps": "number",
        "original_status_verified_at": "Date",
        "vbr_detected_at": "Date",
        "_nullable": [
            "last_file_updated_at",
            "last_verified_at",
            "is_vbr",
            "vbr_detected_at",
            "original_status_verified_at",
            "gvlibrary_bitrate_kbps",
            "original_bitrate_kbps"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BannedArtist": {
        "id": "number",
        "artist": "Artist",
        "artist_id": "number",
        "created_at": "Date",
        "deleted_at": "Date",
        "location_zone_id": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "user_id",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "artist_id",
            "location_zone_id",
            "user_id"
        ],
        "_unique": []
    },
    "BannedTrack": {
        "id": "number",
        "created_at": "Date",
        "deleted_at": "Date",
        "location_zone_id": "number",
        "track": "LiveTrack",
        "track_id": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "user_id",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "user_id",
            "created_at"
        ],
        "_filled": [
            "track_id",
            "location_zone_id"
        ],
        "_unique": []
    },
    "Brand": {
        "id": "number",
        "name": "string",
        "short_name": "string",
        "url": "string",
        "_nullable": [
            "short_name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "short_name",
            "url"
        ],
        "_unique": [
            "name",
            "short_name",
            "url"
        ]
    },
    "BucketArtistOverride": {
        "id": "number",
        "artist": "Artist",
        "artist_id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "override_type": "OverrideType",
        "override_type_id": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "artist_id",
            "bucket_id",
            "override_type_id",
            "user_id"
        ],
        "_unique": []
    },
    "BucketGenre": {
        "id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "bucket_weight": "number",
        "created_at": "Date",
        "genre": "Genre",
        "genre_id": "number",
        "is_dynamic": "boolean",
        "type": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "type",
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "bucket_id",
            "genre_id",
            "bucket_weight",
            "user_id",
            "is_dynamic"
        ],
        "_unique": []
    },
    "BucketTagOverride": {
        "id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "created_at": "Date",
        "tag": "Tag",
        "tag_id": "number",
        "type": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "bucket_id",
            "tag_id",
            "type",
            "user_id"
        ],
        "_unique": []
    },
    "BucketTrackOverride": {
        "id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "override_type": "OverrideType",
        "override_type_id": "number",
        "track": "LiveTrack",
        "track_id": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "bucket_id",
            "track_id",
            "override_type_id",
            "user_id"
        ],
        "_unique": []
    },
    "BucketType": {
        "id": "number",
        "buckets": "Bucket[]",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionName": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionRun": {
        "id": "number",
        "bulk_action_name": "BulkActionName",
        "bulk_action_name_id": "number",
        "bulk_action_run_items": "BulkActionRunItem[]",
        "bulk_action_run_status": "BulkActionRunStatus",
        "bulk_action_run_status_id": "number",
        "created_at": "Date",
        "delete_impact": "any[]",
        "expires_at": "Date",
        "finished_at": "Date",
        "invalid_count": "number",
        "no_value_count": "number",
        "not_found_count": "number",
        "operation": "any[]",
        "queued_at": "Date",
        "selected_count": "number",
        "skipped_for_access_count": "number",
        "started_at": "Date",
        "unchanged_count": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "will_change_count": "number",
        "_nullable": [
            "delete_impact",
            "queued_at",
            "started_at",
            "finished_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionRunItem": {
        "id": "number",
        "bulk_action_run": "BulkActionRun",
        "bulk_action_run_id": "number",
        "bulk_action_run_item_outcome": "BulkActionRunItemOutcome",
        "bulk_action_run_item_outcome_id": "number",
        "bulk_action_run_item_verdict": "BulkActionRunItemVerdict",
        "bulk_action_run_item_verdict_id": "number",
        "created_at": "Date",
        "location": "Location",
        "location_id": "number",
        "location_zone": "LocationZone",
        "location_zone_custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone_custom_playlist_id": "number",
        "location_zone_id": "number",
        "no_value_fields": "any[]",
        "position": "number",
        "record_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "location_zone_id",
            "location_id",
            "location_zone_custom_playlist_id",
            "bulk_action_run_item_outcome_id",
            "no_value_fields"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionRunItemOutcome": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionRunItemVerdict": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "BulkActionRunStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CannedNoteSubject": {
        "id": "number",
        "canned_note_subject_type": "CannedNoteSubjectType",
        "canned_note_subject_type_id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "canned_note_subject_type_id"
        ],
        "_unique": [
            "name"
        ]
    },
    "CannedNoteSubjectType": {
        "id": "number",
        "canned_note_subjects": "CannedNoteSubject[]",
        "created_at": "Date",
        "group_name": "string",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "group_name",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "group_name"
        ],
        "_unique": [
            "name"
        ]
    },
    "Categorizable": {
        "id": "number",
        "category": "Category",
        "category_id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "updated_at": "Date",
        "_nullable": [
            "f_id",
            "f_type",
            "category_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "f_id",
            "f_type",
            "category_id"
        ],
        "_unique": []
    },
    "CategorizablePivot": {
        "id": "number",
        "category_id": "number",
        "f_id": "number",
        "_nullable": [
            "f_id",
            "category_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Category": {
        "id": "number",
        "category_type": "CategoryType",
        "category_type_id": "number",
        "deleted_at": "Date",
        "name": "string",
        "short_name": "string",
        "_nullable": [
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "category_type_id"
        ],
        "_unique": []
    },
    "CategoryType": {
        "id": "number",
        "categories": "Category[]",
        "deleted_at": "Date",
        "_nullable": [
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "ClientwebSubmission": {
        "id": "number",
        "account": "Account",
        "account_id": "number",
        "clientweb_submission_method_id": "number",
        "clientweb_submission_source_id": "number",
        "contact": "Contact",
        "contact_id": "number",
        "created_at": "Date",
        "diff": "string",
        "headers": "string",
        "ip_address": "string",
        "is_processed": "boolean",
        "request": "string",
        "request_encoded": "string",
        "response": "string",
        "session_id": "string",
        "updated_at": "Date",
        "uri": "string",
        "_nullable": [
            "account_id",
            "contact_id",
            "clientweb_submission_source_id",
            "clientweb_submission_method_id",
            "uri",
            "request",
            "response",
            "request_encoded",
            "diff",
            "headers",
            "ip_address"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "account_id",
            "contact_id",
            "clientweb_submission_source_id",
            "clientweb_submission_method_id",
            "uri",
            "request",
            "response",
            "request_encoded",
            "diff",
            "headers",
            "session_id",
            "ip_address",
            "is_processed",
            "created_at",
            "updated_at"
        ],
        "_filled": [],
        "_unique": []
    },
    "ContactLogin": {
        "id": "number",
        "allow_comments_without_votes": "boolean",
        "allows_skipping": "boolean",
        "always_reset_stations": "boolean",
        "contact": "Contact",
        "contact_id": "number",
        "contact_login_type": "ContactLoginType",
        "contact_login_type_id": "number",
        "created_at": "Date",
        "force_password_reset": "boolean",
        "international_playback": "boolean",
        "is_active": "boolean",
        "is_archived": "boolean",
        "laravel_password": "string",
        "login_attempts": "number",
        "master_contact_login": "ContactLogin",
        "master_contact_login_id": "number",
        "password": "string",
        "remember_token": "string",
        "should_debug": "boolean",
        "unlimited_skipping": "boolean",
        "updated_at": "Date",
        "_nullable": [
            "remember_token",
            "force_password_reset",
            "laravel_password",
            "created_at",
            "updated_at",
            "always_reset_stations",
            "master_contact_login_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "contact_id",
            "password",
            "remember_token",
            "force_password_reset",
            "is_active",
            "login_attempts",
            "contact_login_type_id",
            "always_reset_stations",
            "is_archived",
            "unlimited_skipping",
            "international_playback",
            "allow_comments_without_votes",
            "should_debug",
            "allows_skipping",
            "master_contact_login_id"
        ],
        "_unique": []
    },
    "ContactLoginCustomPlaylistTrack": {
        "id": "number",
        "contact_login_custom_playlist_id": "number",
        "created_at": "Date",
        "position": "number",
        "track": "LiveTrack",
        "track_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "contact_login_custom_playlist_id",
            "track_id",
            "position"
        ],
        "_unique": []
    },
    "ContactLoginPlayer": {
        "id": "number",
        "contact_login": "ContactLogin",
        "contact_login_id": "number",
        "initial_contact_date": "Date",
        "is_archived": "boolean",
        "last_follow_up_date": "Date",
        "player_id": "number",
        "shutdown_notice_date": "Date",
        "updated_at": "Date",
        "_nullable": [
            "initial_contact_date",
            "last_follow_up_date",
            "shutdown_notice_date",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "updated_at"
        ],
        "_filled": [
            "contact_login_id",
            "player_id",
            "initial_contact_date",
            "last_follow_up_date",
            "shutdown_notice_date",
            "is_archived"
        ],
        "_unique": []
    },
    "ContactLoginStationSourceType": {
        "id": "number",
        "name": "string",
        "table_name": "string",
        "_nullable": [
            "name",
            "table_name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "table_name"
        ],
        "_unique": [
            "name",
            "table_name"
        ]
    },
    "ContactLoginType": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "Contactable": {
        "id": "number",
        "contact": "Contact",
        "contact_id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "is_archived": "boolean",
        "owner": "Contactable",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "f_id",
            "f_type",
            "contact_id",
            "is_archived"
        ],
        "_unique": []
    },
    "ContentStyle": {
        "id": "number",
        "name": "string",
        "summary": "string",
        "_nullable": [
            "name",
            "summary"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "summary"
        ],
        "_unique": []
    },
    "Country": {
        "id": "number",
        "code": "string",
        "created_at": "Date",
        "name": "string",
        "sort_value": "number",
        "subdivision_type": "string",
        "updated_at": "Date",
        "_nullable": [
            "subdivision_type",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "code",
            "subdivision_type",
            "sort_value"
        ],
        "_unique": [
            "name",
            "sort_value"
        ]
    },
    "CronDdexMatchStatus": {
        "id": "number",
        "reason": "string",
        "_nullable": [
            "reason"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CronDdexRun": {
        "id": "number",
        "end_run": "Date",
        "errors": "string",
        "errors_ddex": "string",
        "imported_tracks": "string",
        "running": "boolean",
        "start_run": "Date",
        "tracks_processed": "number",
        "tracks_processed_ended_at": "Date",
        "tracks_processed_started_at": "Date",
        "updated_tracks": "string",
        "_nullable": [
            "start_run",
            "end_run",
            "running",
            "tracks_processed",
            "tracks_processed_started_at",
            "tracks_processed_ended_at",
            "imported_tracks",
            "updated_tracks",
            "errors",
            "errors_ddex"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CronDdexStageStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CronDdexTrack": {
        "id": "number",
        "album_artist_name": "string",
        "album_ean": "string",
        "album_name": "string",
        "album_upc": "string",
        "artist_name": "string",
        "bitrate": "number",
        "catalog_code": "string",
        "checksum": "string",
        "copyright": "number",
        "cover_art_signed_url": "string",
        "cover_image_checksum": "string",
        "cover_image_file_path": "string",
        "cover_image_processed": "boolean",
        "created_at": "Date",
        "ddex_xml_file": "CronDdexXmlFile",
        "ddx_file": "CronDdexXmlFile",
        "ddx_file_id": "number",
        "ddx_original_file": "CronDdexXmlFile",
        "ddx_original_file_id": "number",
        "ddx_update_file": "CronDdexXmlFile",
        "ddx_update_file_id": "number",
        "duration": "number",
        "error_status": "number",
        "file_path": "string",
        "genre_name": "string",
        "isrc": "string",
        "major_record_label_name": "string",
        "match_status": "CronDdexMatchStatus",
        "match_status_id": "number",
        "message_date": "Date",
        "name": "string",
        "parental_advisory": "string",
        "publishers": "string",
        "record_label_name": "string",
        "release_album_catalog_number": "string",
        "release_album_grid": "string",
        "release_album_icpn": "string",
        "release_grid": "string",
        "run": "CronDdexRun",
        "run_id": "number",
        "solr_status": "number",
        "stage_status": "CronDdexStageStatus",
        "stage_status_id": "number",
        "stage_updated": "Date",
        "sub_genre_name": "string",
        "sub_title": "string",
        "take_down": "boolean",
        "take_down_territories": "string",
        "track_duplicate_artists": "string",
        "track_duplicate_ids": "string",
        "track_duplicate_is_processed": "boolean",
        "track_duplicate_names": "string",
        "track_similar_artists": "string",
        "track_similar_ids": "string",
        "track_similar_names": "string",
        "track_tags_processed": "boolean",
        "update_indicator": "number",
        "updated_at": "Date",
        "uploaded_to_s3": "number",
        "us_take_down": "boolean",
        "_nullable": [
            "ddx_file_id",
            "ddx_original_file_id",
            "ddx_update_file_id",
            "track_duplicate_ids",
            "track_duplicate_names",
            "track_duplicate_artists",
            "track_duplicate_is_processed",
            "track_similar_ids",
            "track_similar_names",
            "track_similar_artists",
            "name",
            "sub_title",
            "artist_name",
            "record_label_name",
            "major_record_label_name",
            "genre_name",
            "sub_genre_name",
            "duration",
            "isrc",
            "copyright",
            "file_path",
            "checksum",
            "bitrate",
            "publishers",
            "parental_advisory",
            "error_status",
            "solr_status",
            "catalog_code",
            "release_grid",
            "album_artist_name",
            "album_name",
            "album_upc",
            "album_ean",
            "release_album_icpn",
            "release_album_catalog_number",
            "release_album_grid",
            "cover_image_file_path",
            "cover_art_signed_url",
            "cover_image_checksum",
            "cover_image_processed",
            "update_indicator",
            "message_date",
            "updated_at",
            "take_down",
            "uploaded_to_s3",
            "track_tags_processed",
            "match_status_id",
            "stage_status_id",
            "stage_updated",
            "take_down_territories",
            "us_take_down"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "run_id",
            "track_duplicate_is_processed"
        ],
        "_unique": []
    },
    "CronDdexTracksDeal": {
        "id": "number",
        "created_at": "Date",
        "ddx_file_id": "number",
        "deal_commercial_type": "string",
        "deal_end": "Date",
        "deal_start": "Date",
        "deal_territory": "string",
        "deal_territory_excluded": "string",
        "deal_use_type": "string",
        "effective_date": "Date",
        "message_date": "Date",
        "run_id": "number",
        "track_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "ddx_file_id",
            "track_id",
            "message_date",
            "effective_date",
            "deal_commercial_type",
            "deal_use_type",
            "deal_territory",
            "deal_territory_excluded",
            "deal_start",
            "deal_end",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CronDdexTracksTakedownStatus": {
        "id": "number",
        "description": "string",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CronDdexXmlFile": {
        "id": "number",
        "ack_status": "number",
        "checksum": "string",
        "cover_art_processed": "number",
        "cron_ddex_tracks": "CronDdexTrack[]",
        "cron_ddex_xml_release_type_id": "number",
        "ddex_ern_version": "number",
        "ddex_processed": "number",
        "error_status": "boolean",
        "file_name": "string",
        "file_type": "boolean",
        "folder_path": "string",
        "folder_path_s3": "string",
        "generated_ack": "number",
        "hostname": "string",
        "message_date": "Date",
        "message_id": "string",
        "message_thread_id": "string",
        "party_id_receiver": "string",
        "party_id_sender": "string",
        "party_id_sent_on_behalf": "string",
        "processed": "number",
        "processed_date": "Date",
        "re_indexed": "boolean",
        "removed_disk": "number",
        "run_id": "number",
        "tracks_processed": "number",
        "update_indicator": "number",
        "uploaded_s3": "boolean",
        "uploaded_temp_s3": "boolean",
        "_nullable": [
            "run_id",
            "file_type",
            "removed_disk",
            "folder_path_s3",
            "generated_ack",
            "ack_status",
            "cover_art_processed",
            "tracks_processed",
            "party_id_receiver",
            "party_id_sender",
            "party_id_sent_on_behalf",
            "message_thread_id",
            "message_id",
            "message_date",
            "update_indicator",
            "error_status",
            "re_indexed",
            "checksum",
            "ddex_ern_version",
            "cron_ddex_xml_release_type_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "CrossfadeType": {
        "id": "number",
        "name": "string",
        "players": "Player[]",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "CustomPlaylistInsertType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "CustomPlaylistScheduleType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "CustomPlaylistSwitchStat": {
        "id": "number",
        "contact": "Contact",
        "contact_id": "number",
        "location_zone_custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone_custom_playlist_id": "number",
        "report_date": "Date",
        "switch_count": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Day": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "short_name": "string",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "short_name"
        ],
        "_unique": [
            "name",
            "short_name"
        ]
    },
    "DdexConfiguration": {
        "id": "number",
        "created_at": "Date",
        "created_by_user": "User",
        "created_by_user_id": "number",
        "enabled": "boolean",
        "exclusions": "RawDdexPartyExclusion[]",
        "raw_ddex_party_sender_id": "number",
        "s3_import_path": "string",
        "sender": "RawDdexParty",
        "updated_at": "Date",
        "_nullable": [
            "created_by_user_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "raw_ddex_party_sender_id"
        ],
        "_filled": [],
        "_unique": []
    },
    "DynamoDbBaseModel": {
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackPlayDynamo": {
        "country_id": "number",
        "ip_address": "string",
        "job_id": "string",
        "live_track_code": "string",
        "live_track_id": "number",
        "partition_key": "string",
        "play_month": "string",
        "play_month_country": "string",
        "play_timestamp": "number",
        "player_primary_key": "string",
        "player_type_id": "number",
        "track_id_country_id_track_stream_type_id": "string",
        "track_stream_type_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerCommandHistory": {
        "acknowledged_at": "number",
        "command": "string",
        "command_hash": "string",
        "command_id": "string",
        "command_truncated": "boolean",
        "delivered_at": "number",
        "expires_at": "number",
        "issued_at": "number",
        "location_zone_player_id": "number",
        "skipped_reason": "string",
        "source": "string",
        "state": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerPlaylistDynamo": {
        "id": "number",
        "created_at": "Date",
        "days_remaining": "number",
        "location_zone_player_id": "number",
        "playlists": "string",
        "updated_at": "Date",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LzpLogs2": {
        "created_at": "Date",
        "live_track": "LiveTrack",
        "location_zone_player_id": "number",
        "message": "string",
        "time": "number",
        "track_code": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayDailyData": {
        "code": "string",
        "country": "Country",
        "created_at": "Date",
        "date": "string",
        "live_track": "LiveTrack",
        "remote_address": "string",
        "stream": "boolean",
        "stream_id": "string",
        "time": "number",
        "track_stream_type_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayMobileData": {
        "code": "string",
        "contact_id": "number",
        "country": "Country",
        "country_code": "string",
        "created_at": "Date",
        "live_track": "LiveTrack",
        "remote_address": "string",
        "station_id": "number",
        "timestamp": "number",
        "track_stream_type_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayWebData": {
        "id": "string",
        "code": "string",
        "country": "Country",
        "created_at": "Date",
        "listid": "number",
        "live_track": "LiveTrack",
        "remote_address": "string",
        "timestamp": "number",
        "track_stream_type_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayWebsamplelistData": {
        "code": "string",
        "country": "Country",
        "country_code": "string",
        "created_at": "Date",
        "live_track": "LiveTrack",
        "remote_address": "string",
        "timestamp": "number",
        "token": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "ZpDynamo": {
        "id": "number",
        "archive_name": "string",
        "attempt_time_stamp": "Date",
        "created_at": "Date",
        "delimited_bucket_ids": "string",
        "delimited_track_codes": "string",
        "delimited_track_details": "string",
        "delimited_track_ids": "string",
        "expiry_timestamp": "number",
        "file_name": "string",
        "location_zone_id": "number",
        "play_date": "Date",
        "play_date_time": "Date",
        "playlist_generation_attempt_id": "number",
        "playlist_generation_attempt_id_play_date_time": "number",
        "success": "number",
        "tableName": "string",
        "updated_at": "number",
        "utc_attempt_timestamp": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "DynamoDbTableStatistic": {
        "id": "number",
        "captured_at": "Date",
        "item_count": "number",
        "size_bytes": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "DynamoPrimaryKeyQueue": {
        "id": "number",
        "failure_count": "number",
        "pk_value": "string",
        "processing_started_at": "Date",
        "table_name": "string",
        "_nullable": [
            "processing_started_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Extension": {
        "id": "number",
        "created_at": "Date",
        "number": "string",
        "parent_id": "number",
        "parent_type": "string",
        "phone_number_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [],
        "_unique": [
            "number"
        ]
    },
    "FavoriteFilter": {
        "id": "number",
        "created_at": "Date",
        "entity": "string",
        "label": "string",
        "rule": "any[]",
        "signature": "string",
        "signature_hash": "string",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "rule.column",
            "rule.criterion"
        ],
        "_unique": []
    },
    "FileDownload": {
        "id": "number",
        "created_at": "Date",
        "error_message": "string",
        "file_name": "string",
        "status": "'DOWNLOADING' | 'SUCCESS' | 'FAILURE'",
        "updated_at": "Date",
        "_nullable": [
            "error_message",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Genre": {
        "id": "number",
        "comments": "string",
        "created_at": "Date",
        "deleted_at": "Date",
        "g_description": "string",
        "live_tracks": "LiveTrack[]",
        "name": "string",
        "summary": "string",
        "tags": "Tag",
        "updated_at": "Date",
        "variation": "number",
        "_nullable": [
            "name",
            "g_description",
            "comments",
            "summary",
            "variation",
            "created_at",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "g_description",
            "comments",
            "summary",
            "variation"
        ],
        "_unique": [
            "name",
            "g_description",
            "comments",
            "summary"
        ]
    },
    "Holiday": {
        "id": "number",
        "name": "string",
        "natural_language_description": "string",
        "normalized_name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Insert": {
        "id": "number",
        "allow_repeats": "boolean",
        "created_at": "Date",
        "disabled": "boolean",
        "duration": "number",
        "duration_type": "number",
        "end_date": "Date",
        "frequency": "number",
        "name": "string",
        "object": "Bucket",
        "object_id": "number",
        "object_type": "string",
        "play_type": "number",
        "saturation": "number",
        "start_date": "Date",
        "template": "Template",
        "template_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "duration_type",
            "created_at",
            "play_type",
            "saturation",
            "allow_repeats"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "object_type",
            "name"
        ],
        "_unique": []
    },
    "LiveTrackActionStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackDeal": {
        "id": "number",
        "commercial_model_type": "any[]",
        "excluded_territory_codes": "any[]",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "territory_codes": "any[]",
        "usage": "any[]",
        "validity_period_end_date": "Date",
        "validity_period_start_date": "Date",
        "_nullable": [
            "validity_period_start_date",
            "validity_period_end_date",
            "excluded_territory_codes"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackEchoprintState": {
        "id": "number",
        "created_at": "Date",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "reingested_at": "Date",
        "updated_at": "Date",
        "_nullable": [
            "reingested_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackMatch": {
        "id": "number",
        "confidence_score": "number",
        "created_at": "Date",
        "fingerprint_match": "boolean",
        "fingerprint_via": "string",
        "fuzzy_match": "boolean",
        "isrc_match": "boolean",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "matched_track_data": "any[]",
        "matched_track_id": "string",
        "source_type": "string",
        "updated_at": "Date",
        "_nullable": [
            "fingerprint_via",
            "confidence_score",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackMatchType": {
        "id": "number",
        "created_at": "Date",
        "live_track_matches": "LiveTrackMatch[]",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LiveTrackPlaySummary": {
        "id": "number",
        "country": "Country",
        "country_id": "number",
        "live_track": "LiveTrack",
        "live_track_id": "number",
        "per_play_source_type": "PerPlaySourceType",
        "per_play_source_type_id": "number",
        "play_month": "string",
        "plays": "number",
        "track_stream_type": "TrackStreamType",
        "track_stream_type_id": "number",
        "_nullable": [
            "country_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "live_track_id",
            "country_id",
            "track_stream_type_id",
            "per_play_source_type_id",
            "plays",
            "play_month"
        ],
        "_unique": []
    },
    "LiveTrackReportSnapshot": {
        "id": "number",
        "album_display_string": "string",
        "album_id": "number",
        "album_upc": "string",
        "artist_display_string": "string",
        "artist_id": "number",
        "catalog_code": "string",
        "is_partner": "boolean",
        "isrc": "string",
        "live_track_id": "number",
        "record_label_display_string": "string",
        "record_label_id": "number",
        "report_month": "number",
        "root_record_label_display_string": "string",
        "root_record_label_id": "number",
        "track_name": "string",
        "_nullable": [
            "track_name",
            "isrc",
            "catalog_code",
            "artist_id",
            "artist_display_string",
            "record_label_id",
            "record_label_display_string",
            "root_record_label_id",
            "root_record_label_display_string",
            "is_partner",
            "album_id",
            "album_display_string",
            "album_upc"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationStatus": {
        "id": "number",
        "deleted_at": "Date",
        "_nullable": [
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "LocationZoneContentChangeLog": {
        "id": "number",
        "created_at": "Date",
        "custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone": "LocationZone",
        "location_zone_custom_playlist_id": "number",
        "location_zone_id": "number",
        "requires_publish": "boolean",
        "subject_id": "number",
        "subject_name": "string",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id",
            "subject_id",
            "subject_name",
            "location_zone_custom_playlist_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneContentPublish": {
        "id": "number",
        "command_id": "string",
        "created_at": "Date",
        "location_zone": "LocationZone",
        "location_zone_content_publish_source_id": "number",
        "location_zone_id": "number",
        "players_skipped": "number",
        "players_targeted": "number",
        "source": "LocationZoneContentPublishSource",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id",
            "command_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneContentPublishSource": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneContentState": {
        "id": "number",
        "content_changed_at": "Date",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "_nullable": [
            "content_changed_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneCustomPlaylistSource": {
        "id": "number",
        "details": "string",
        "location_zone_custom_playlist_sources": "string",
        "name": "string",
        "_nullable": [
            "name",
            "details",
            "location_zone_custom_playlist_sources"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneCustomPlaylistStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "LocationZoneCustomPlaylistTrack": {
        "id": "number",
        "created_at": "Date",
        "location_zone_custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone_custom_playlist_id": "number",
        "position": "number",
        "track": "LiveTrack",
        "track_id": "number",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "location_zone_custom_playlist_id",
            "track_id",
            "position"
        ],
        "_unique": []
    },
    "LocationZoneFee": {
        "id": "number",
        "invoicing_approved": "boolean",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "original_startup_fee": "number",
        "original_subscription_fee": "number",
        "past_due_amount": "number",
        "past_due_assigned_to_user_id": "number",
        "past_due_days": "number",
        "payments_tally": "number",
        "primary_pro_location_zone": "LocationZone",
        "primary_pro_location_zone_id": "number",
        "service_agreement_term_id": "number",
        "shipping_fee": "number",
        "startup_date": "Date",
        "startup_fee": "number",
        "startup_fee_is_paid": "boolean",
        "startup_invoice_balance_status_id": "number",
        "startup_invoicing_status_id": "number",
        "subscription_fee": "number",
        "subscription_invoicing_status_id": "number",
        "term_end_date": "Date",
        "zero_startup_fee_reason": "string",
        "_nullable": [
            "location_zone_id",
            "startup_fee",
            "subscription_fee",
            "startup_date",
            "primary_pro_location_zone_id",
            "term_end_date",
            "service_agreement_term_id",
            "invoicing_approved",
            "shipping_fee",
            "startup_invoicing_status_id",
            "subscription_invoicing_status_id",
            "past_due_amount",
            "past_due_days",
            "startup_fee_is_paid",
            "startup_invoice_balance_status_id",
            "past_due_assigned_to_user_id",
            "zero_startup_fee_reason",
            "original_startup_fee",
            "original_subscription_fee"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZoneHour": {
        "id": "number",
        "close_time": "string",
        "created_at": "Date",
        "day_id": "number",
        "deleted_at": "Date",
        "is_closed": "boolean",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "open_time": "string",
        "updated_at": "Date",
        "_nullable": [
            "open_time",
            "close_time",
            "is_closed",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "location_zone_id",
            "day_id",
            "open_time",
            "close_time",
            "is_closed"
        ],
        "_unique": []
    },
    "LocationZonePlaybackTimeframe": {
        "id": "number",
        "day_of_week": "number",
        "end_time": "string",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "start_time": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerCommandEnum": {
        "id": "number",
        "command": "string",
        "is_hardware_player_command_only": "boolean",
        "is_virtual_player_command_only": "boolean",
        "json_command": "string",
        "menu_name": "string",
        "name": "string",
        "position": "number",
        "requires_legacy_handler": "boolean",
        "should_prefix_separator": "boolean",
        "version_maximum": "string",
        "version_minimum": "string",
        "_nullable": [
            "menu_name",
            "position",
            "json_command",
            "version_minimum",
            "version_maximum"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerCommandQueue": {
        "id": "number",
        "command": "string",
        "created_at": "Date",
        "issued_at": "Date",
        "location_zone_player": "LocationZonePlayer",
        "location_zone_player_id": "number",
        "scheduled_time": "Date",
        "_nullable": [
            "scheduled_time",
            "issued_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "location_zone_player_id",
            "command"
        ],
        "_unique": []
    },
    "LocationZonePlayerData": {
        "id": "number",
        "account": "Account",
        "channels": "string",
        "checkin_marker": "Date",
        "created_at": "Date",
        "current_playlist_name": "string",
        "current_track_code": "string",
        "date": "Date",
        "disk_size_gb": "number",
        "disk_usage": "string",
        "disk_usage_percentage": "number",
        "drive": "string",
        "gateway": "string",
        "internal_ip": "string",
        "ip_mode": "string",
        "is_internal": "boolean",
        "is_online": "boolean",
        "kernel": "string",
        "lan": "string",
        "last_loaded_archive": "string",
        "last_loaded_date": "Date",
        "location": "Location",
        "location_zone": "LocationZone",
        "location_zone_player": "LocationZonePlayer",
        "location_zone_player_id": "number",
        "mac_address": "string",
        "model_type": "string",
        "network_info": "string",
        "player_type": "PlayerType",
        "player_type_id": "number",
        "playing": "number",
        "playlist_track_number": "number",
        "playlist_track_total": "number",
        "proxy": "string",
        "referenced_content_missing": "number",
        "referenced_content_total": "number",
        "remote_ip": "string",
        "subnet": "string",
        "time_zone": "string",
        "updated_at": "Date",
        "version": "string",
        "volume": "number",
        "_nullable": [
            "location_zone_player_id",
            "current_track_code",
            "current_playlist_name",
            "last_loaded_date",
            "last_loaded_archive",
            "disk_usage",
            "disk_usage_percentage",
            "disk_size_gb",
            "lan",
            "date",
            "time_zone",
            "version",
            "volume",
            "network_info",
            "created_at",
            "updated_at",
            "remote_ip",
            "mac_address",
            "checkin_marker",
            "player_type_id",
            "channels",
            "drive",
            "gateway",
            "internal_ip",
            "kernel",
            "model_type",
            "proxy",
            "subnet",
            "ip_mode"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerHolidayMusicStatus": {
        "id": "number",
        "created_at": "Date",
        "has_played_holiday_music": "boolean",
        "last_checked_at": "Date",
        "last_holiday_play_at": "Date",
        "location_zone_player_id": "number",
        "track_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "track_id",
            "last_checked_at",
            "last_holiday_play_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerParsedPlaylist": {
        "id": "number",
        "created_at": "Date",
        "location_zone_id": "number",
        "location_zone_player_id": "number",
        "playlist_id": "number",
        "playlist_name": "string",
        "table_name": "string",
        "updated_at": "Date",
        "_nullable": [
            "location_zone_id",
            "playlist_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerPlaylist": {
        "id": "number",
        "created_at": "Date",
        "days_remaining": "number",
        "location_zone_id": "number",
        "location_zone_player": "LocationZonePlayer",
        "location_zone_player_id": "number",
        "playlists": "string",
        "updated_at": "Date",
        "_nullable": [
            "location_zone_id",
            "location_zone_player_id",
            "playlists",
            "created_at",
            "updated_at",
            "days_remaining"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "LocationZonePlayerStreamMode": {
        "id": "number",
        "location_zone_players": "LocationZonePlayer[]",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "LocationZoneStatus": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [],
        "_unique": []
    },
    "LocationZoneTier": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "LocationZoneVote": {
        "id": "number",
        "clonedFromLocationZoneVote": "LocationZoneVote",
        "cloned_from_location_zone_vote_id": "number",
        "comment": "string",
        "contact": "Contact",
        "contact_id": "number",
        "created_at": "Date",
        "deleted_at": "Date",
        "is_internal_comment": "boolean",
        "locationZone": "LocationZone",
        "location_zone_id": "number",
        "source_name": "string",
        "track": "LiveTrack",
        "track_id": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "vote": "number",
        "voteReason": "VoteReason",
        "voteType": "VoteType",
        "vote_reason_id": "number",
        "vote_type_id": "number",
        "_nullable": [
            "user_id",
            "contact_id",
            "comment",
            "vote_reason_id",
            "source_name",
            "vote_type_id",
            "cloned_from_location_zone_vote_id",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "location_zone_id",
            "track_id",
            "vote",
            "is_internal_comment"
        ],
        "_unique": []
    },
    "LyricsCheckStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "MasterServiceAgreement": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "ModelPermissionDefinition": {
        "id": "number",
        "created_at": "Date",
        "sort_order": "number",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "ModelSnapshot": {
        "id": "number",
        "changes": "string",
        "created_at": "Date",
        "payload": "string",
        "performed_by_user": "User",
        "performed_by_user_id": "number",
        "table": "string",
        "updated_at": "Date",
        "_nullable": [
            "performed_by_user_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "performed_by_user_id",
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "table",
            "payload",
            "changes"
        ],
        "_unique": []
    },
    "MonthlyActiveZone": {
        "id": "number",
        "account": "string",
        "account_id": "number",
        "country": "Country",
        "country_id": "number",
        "equipment_fee": "number",
        "location": "string",
        "location_id": "number",
        "net_monthly_revenue": "number",
        "primary_pro_location_zone": "string",
        "primary_pro_location_zone_id": "number",
        "pro_fee": "number",
        "pro_zone_fee": "number",
        "report_month": "number",
        "startup_date": "Date",
        "startup_fee": "number",
        "subscription_fee": "number",
        "zone": "string",
        "zone_id": "number",
        "_nullable": [
            "country_id",
            "primary_pro_location_zone_id",
            "primary_pro_location_zone",
            "equipment_fee",
            "pro_fee",
            "pro_zone_fee",
            "net_monthly_revenue",
            "startup_date"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Note": {
        "id": "number",
        "assigned_user": "User",
        "assigned_user_id": "number",
        "completed_notification_was_sent": "boolean",
        "created_at": "Date",
        "due_date": "Date",
        "due_date_is_enabled": "boolean",
        "is_archived": "boolean",
        "is_complete": "boolean",
        "is_high_priority": "boolean",
        "is_tpg_note": "boolean",
        "last_notification_date": "Date",
        "last_past_due_notification_date": "Date",
        "message": "string",
        "note_type_id": "number",
        "parent": "Note",
        "parent_id": "number",
        "parent_note_id": "number",
        "parent_string_value": "string",
        "parent_type": "string",
        "reference_message_id": "string",
        "start_date": "Date",
        "start_date_is_enabled": "boolean",
        "start_notification_was_sent": "boolean",
        "subject": "string",
        "time_zone": "TimeZone",
        "time_zone_id": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "parent_id",
            "parent_type",
            "created_at",
            "start_date",
            "parent_note_id",
            "last_notification_date",
            "due_date",
            "last_past_due_notification_date",
            "reference_message_id",
            "assigned_user_id",
            "time_zone_id",
            "is_tpg_note",
            "parent_string_value",
            "is_high_priority"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "subject",
            "message",
            "user_id",
            "note_type_id",
            "parent_id",
            "parent_type",
            "start_date_is_enabled",
            "is_complete",
            "due_date_is_enabled",
            "completed_notification_was_sent",
            "start_notification_was_sent",
            "last_past_due_notification_date",
            "time_zone_id",
            "is_tpg_note",
            "parent_string_value",
            "is_high_priority",
            "is_archived"
        ],
        "_unique": []
    },
    "NoteBox": {
        "id": "number",
        "assigned_to_user": "User",
        "assigned_to_user_id": "number",
        "belongs_to_parent_id": "number",
        "belongs_to_parent_type": "string",
        "brand_is_grayv": "boolean",
        "brand_is_tpg": "boolean",
        "cc_to_user_": "User",
        "cc_to_user_id": "number",
        "created_by_user": "User",
        "created_by_user_id": "number",
        "is_completed": "boolean",
        "is_high_priority": "boolean",
        "is_open": "boolean",
        "is_system_note": "boolean",
        "is_user_note": "boolean",
        "max_create_date": "Date",
        "max_create_date_offset": "number",
        "max_due_date": "Date",
        "max_due_date_offset": "number",
        "max_start_date": "Date",
        "max_start_date_offset": "number",
        "min_create_date": "Date",
        "min_create_date_offset": "number",
        "min_due_date": "Date",
        "min_due_date_offset": "number",
        "min_start_date": "Date",
        "min_start_date_offset": "number",
        "name": "string",
        "parent_types": "string",
        "subject": "string",
        "task_is_completed": "boolean",
        "task_is_open": "boolean",
        "task_to_user_": "User",
        "task_to_user_id": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id",
            "is_user_note",
            "is_system_note",
            "is_open",
            "is_completed",
            "is_high_priority",
            "assigned_to_user_id",
            "cc_to_user_id",
            "task_to_user_id",
            "task_is_open",
            "task_is_completed",
            "created_by_user_id",
            "min_create_date",
            "max_create_date",
            "min_create_date_offset",
            "max_create_date_offset",
            "min_start_date",
            "max_start_date",
            "min_start_date_offset",
            "max_start_date_offset",
            "min_due_date",
            "max_due_date",
            "min_due_date_offset",
            "max_due_date_offset",
            "brand_is_tpg",
            "brand_is_grayv",
            "parent_types",
            "belongs_to_parent_type",
            "belongs_to_parent_id",
            "subject"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "user_id",
            "is_user_note",
            "is_system_note",
            "is_open",
            "is_completed",
            "is_high_priority",
            "assigned_to_user_id",
            "cc_to_user_id",
            "task_to_user_id",
            "task_is_open",
            "task_is_completed",
            "created_by_user_id",
            "min_create_date",
            "max_create_date",
            "min_create_date_offset",
            "max_create_date_offset",
            "min_start_date",
            "max_start_date",
            "min_start_date_offset",
            "max_start_date_offset",
            "min_due_date",
            "max_due_date",
            "min_due_date_offset",
            "max_due_date_offset",
            "brand_is_tpg",
            "brand_is_grayv",
            "parent_types",
            "belongs_to_parent_type",
            "belongs_to_parent_id",
            "subject"
        ],
        "_unique": []
    },
    "NoteType": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "NoteUser": {
        "id": "number",
        "created_at": "Date",
        "has_task_assigned": "boolean",
        "is_watcher": "boolean",
        "note": "Note",
        "note_id": "number",
        "task_is_completed": "boolean",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at",
            "z_is_assignee"
        ],
        "_filled": [
            "note_id",
            "user_id",
            "is_watcher",
            "has_task_assigned",
            "task_is_completed"
        ],
        "_unique": []
    },
    "NotionSlackChannel": {
        "id": "number",
        "channel_move_count": "number",
        "created_at": "Date",
        "exported_at": "Date",
        "last_caught_up_at": "Date",
        "notionSlackMessages": "NotionSlackMessage[]",
        "updated_at": "Date",
        "_nullable": [
            "exported_at",
            "last_caught_up_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "NotionSlackMessage": {
        "id": "number",
        "channel_move_count": "number",
        "created_at": "Date",
        "notionSlackChannel": "NotionSlackChannel",
        "notion_slack_channel_id": "number",
        "removed_from_notion": "boolean",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "NotionWebhookEvent": {
        "id": "number",
        "created_at": "Date",
        "event_timestamp": "Date",
        "processed_at": "Date",
        "received_at": "Date",
        "updated_at": "Date",
        "updated_property_ids": "any[]",
        "_nullable": [
            "updated_property_ids",
            "event_timestamp",
            "processed_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "NotionWebhookVerificationToken": {
        "id": "number",
        "received_at": "Date",
        "verification_token": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "OrchardTrack": {
        "id": "number",
        "artists": "string",
        "files": "string",
        "genre": "string",
        "is_artist_match": "boolean",
        "is_isrc_match": "boolean",
        "isrc": "string",
        "remix": "string",
        "should_ingest": "boolean",
        "title": "string",
        "_nullable": [
            "title",
            "remix",
            "artists",
            "isrc",
            "genre",
            "files"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "should_ingest"
        ],
        "_unique": []
    },
    "OverrideType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "PageDefinition": {
        "id": "number",
        "created_at": "Date",
        "modelPermissionDefinitions": "ModelPermissionDefinition",
        "sort_order": "number",
        "updated_at": "Date",
        "user_page_grants": "UserPageGrant[]",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "ParentalAdvisoryType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Part": {
        "id": "number",
        "location_zone_id": "number",
        "name": "string",
        "part_entries": "PartEntry[]",
        "position": "number",
        "template_day_id": "number",
        "template_id": "number",
        "_nullable": [
            "name",
            "template_day_id",
            "location_zone_id",
            "position",
            "template_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "template_day_id",
            "location_zone_id",
            "position",
            "template_id"
        ],
        "_unique": []
    },
    "PartEntry": {
        "id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "duration": "number",
        "part": "Part",
        "part_id": "number",
        "_nullable": [
            "bucket_id",
            "duration",
            "part_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "bucket_id",
            "duration",
            "part_id"
        ],
        "_unique": []
    },
    "PaymentType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "PerPlaySourceType": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PhoneNumber": {
        "id": "number",
        "categories": "Category",
        "created_at": "Date",
        "number": "string",
        "phoneables": "Phoneable[]",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "number"
        ],
        "_unique": []
    },
    "Phoneable": {
        "id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "owner": "Phoneable",
        "phone_number": "PhoneNumber",
        "phone_number_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "f_id",
            "f_type",
            "phone_number_id"
        ],
        "_unique": []
    },
    "PlayLogImportProgress": {
        "id": "number",
        "completed_at": "Date",
        "first_date": "Date",
        "job_id": "string",
        "last_date": "Date",
        "last_updated_at": "Date",
        "lines_processed": "number",
        "percent_complete": "number",
        "play_month": "string",
        "play_month_play_count": "number",
        "s3_key": "string",
        "started_at": "Date",
        "total_created": "number",
        "total_lines": "number",
        "total_processed": "number",
        "total_skipped": "number",
        "_nullable": [
            "job_id",
            "total_lines",
            "play_month_play_count",
            "lines_processed",
            "percent_complete",
            "total_processed",
            "total_created",
            "total_skipped",
            "first_date",
            "last_date",
            "started_at",
            "last_updated_at",
            "completed_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Player": {
        "id": "number",
        "alternate_dns_1": "string",
        "alternate_dns_2": "string",
        "auth_tok": "string",
        "check_interval": "number",
        "created_at": "Date",
        "curlcli": "boolean",
        "location_zone_players": "LocationZonePlayer[]",
        "nrm": "string",
        "player_server": "PlayerServer",
        "player_server_id": "number",
        "player_type": "PlayerType",
        "player_type_id": "number",
        "protocol": "string",
        "stream_logging": "boolean",
        "throttle": "number",
        "time_zone": "string",
        "time_zone_id": "number",
        "timezone": "TimeZone",
        "updated_at": "Date",
        "use_public_dns_servers": "boolean",
        "_nullable": [
            "check_interval",
            "throttle",
            "time_zone",
            "player_server_id",
            "auth_tok",
            "created_at",
            "updated_at",
            "time_zone_id",
            "stream_logging",
            "use_public_dns_servers",
            "alternate_dns_1",
            "alternate_dns_2",
            "player_type_id",
            "nrm",
            "protocol",
            "curlcli"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "player_server_id",
            "auth_tok",
            "time_zone_id",
            "stream_logging",
            "use_public_dns_servers",
            "alternate_dns_1",
            "alternate_dns_2",
            "player_type_id",
            "protocol"
        ],
        "_unique": []
    },
    "PlayerServer": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "players": "Player[]",
        "short_name": "string",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "created_at",
            "updated_at",
            "short_name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "short_name"
        ],
        "_unique": [
            "name",
            "short_name"
        ]
    },
    "PlayerType": {
        "id": "number",
        "name": "string",
        "players": "Player[]",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "PlaylistGenerationAttempt": {
        "id": "number",
        "add_command_issued": "string",
        "attempt_time_stamp": "Date",
        "autogen": "boolean",
        "autoload": "number",
        "cli_command": "string",
        "created_at": "Date",
        "debug_repeats": "string",
        "did_copy_to_dynamo": "boolean",
        "expiration": "Date",
        "is_beta_generator": "boolean",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "location_zone_name": "string",
        "number_of_days": "number",
        "pg_version": "string",
        "playlist_generation_status": "PlaylistGenerationStatus",
        "playlist_generation_status_id": "number",
        "playlists_count": "number",
        "start_date": "Date",
        "status": "number",
        "success": "number",
        "template": "Template",
        "template_id": "number",
        "template_name": "string",
        "user": "User",
        "user_id": "number",
        "verified_by": "string",
        "verified_download_date": "Date",
        "verified_location_zone_player_id": "number",
        "zip_path": "string",
        "_nullable": [
            "location_zone_name",
            "playlist_generation_status_id",
            "zip_path",
            "user_id",
            "created_at",
            "template_name",
            "number_of_days",
            "start_date",
            "template_id",
            "add_command_issued",
            "playlists_count",
            "verified_download_date",
            "verified_location_zone_player_id",
            "verified_by",
            "pg_version",
            "debug_repeats",
            "cli_command",
            "expiration"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "location_zone_id",
            "success",
            "attempt_time_stamp",
            "number_of_days",
            "autoload",
            "playlists_count",
            "is_beta_generator",
            "did_copy_to_dynamo"
        ],
        "_unique": []
    },
    "PlaylistGenerationFailure": {
        "id": "number",
        "attempt": "PlaylistGenerationAttempt",
        "attempt_id": "number",
        "deleted_at": "Date",
        "error_message": "string",
        "failure_type": "string",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "occurred_at": "Date",
        "_nullable": [
            "attempt_id",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PlaylistGenerationStatus": {
        "id": "number",
        "name": "string",
        "playlist_generation_attempts": "PlaylistGenerationAttempt[]",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PlaylistManagerGroup": {
        "id": "number",
        "accounts": "Account[]",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "PlaylistTrack": {
        "id": "number",
        "bucket": "Bucket",
        "custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "source_id": "number",
        "source_is_bucket": "boolean",
        "track_id": "number",
        "_nullable": [
            "location_zone_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PlaylistTrackCount": {
        "source_id": "number",
        "source_is_bucket": "boolean",
        "track_count": "number",
        "track_count_counted_at": "Date",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PlaylistTrackRefreshChangedTrack": {
        "id": "number",
        "created_at": "Date",
        "track_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexErnMessage": {
        "id": "number",
        "behalf_party_id": "any[]",
        "created_at": "Date",
        "ern_version": "string",
        "file_name": "string",
        "message_date": "Date",
        "message_id": "string",
        "message_thread_id": "string",
        "message_type": "string",
        "processed_date": "Date",
        "raw_ddex_sound_recording_releases": "RawDdexSoundRecordingRelease[]",
        "raw_ddex_tracks": "RawDdexTrack[]",
        "raw_ddex_xml_file": "RawDdexXmlFile",
        "raw_ddex_xml_file_id": "number",
        "receiver_party_id": "any[]",
        "release_count": "number",
        "sender_party_id": "any[]",
        "skipped_at": "Date",
        "skipped_exclusion": "RawDdexPartyExclusion",
        "skipped_raw_ddex_party_exclusion_id": "number",
        "skipped_reason": "string",
        "sound_recording_count": "number",
        "update_indicator": "string",
        "updated_at": "Date",
        "_nullable": [
            "raw_ddex_xml_file_id",
            "message_thread_id",
            "file_name",
            "receiver_party_id",
            "sender_party_id",
            "behalf_party_id",
            "processed_date",
            "skipped_at",
            "skipped_reason",
            "skipped_raw_ddex_party_exclusion_id",
            "created_at",
            "updated_at",
            "update_indicator"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "message_type",
            "file_name",
            "message_id",
            "uploaded_s3",
            "receiver_party_id",
            "sender_party_id",
            "behalf_party_id",
            "message_date",
            "processed_date",
            "ern_version"
        ],
        "_unique": [
            "raw_ddex_xml_file_id"
        ]
    },
    "RawDdexInvalidLabelUrlCheck": {
        "id": "number",
        "content_length": "number",
        "content_type": "string",
        "created_at": "Date",
        "detail": "string",
        "http_status": "number",
        "raw_ddex_sound_recording_release": "RawDdexSoundRecordingRelease",
        "raw_ddex_sound_recording_release_id": "number",
        "source_column": "string",
        "updated_at": "Date",
        "url": "string",
        "url_hash": "string",
        "verdict": "string",
        "_nullable": [
            "http_status",
            "content_type",
            "content_length",
            "detail",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexMessageType": {
        "id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexParty": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "party_id": "string",
        "raw_ddex_tracks_as_sender": "RawDdexTrack[]",
        "raw_ddex_tracks_as_sent_on_behalf_of": "RawDdexTrack[]",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "party_id",
            "name"
        ],
        "_unique": [
            "party_id"
        ]
    },
    "RawDdexPartyExclusion": {
        "id": "number",
        "configuration": "DdexConfiguration",
        "created_at": "Date",
        "created_by_user": "User",
        "created_by_user_id": "number",
        "ddex_configuration_id": "number",
        "raw_ddex_party_sender_id": "number",
        "raw_ddex_party_sent_on_behalf_of_id": "number",
        "reason": "string",
        "sender": "RawDdexParty",
        "sent_on_behalf_of": "RawDdexParty",
        "tracks_purge_queued_at": "Date",
        "tracks_purged_at": "Date",
        "updated_at": "Date",
        "_nullable": [
            "raw_ddex_party_sender_id",
            "raw_ddex_party_sent_on_behalf_of_id",
            "reason",
            "created_by_user_id",
            "tracks_purge_queued_at",
            "tracks_purged_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "RawDdexReleaseType": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "raw_ddex_sound_recording_releases": "RawDdexSoundRecordingRelease[]",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexSoundRecordingRelease": {
        "id": "number",
        "album_artists": "any[]",
        "album_name": "string",
        "artists": "any[]",
        "audio_file_checksum": "string",
        "audio_file_s3_path": "string",
        "bitrate": "number",
        "catalog_number": "string",
        "commercial_model_type": "any[]",
        "copyright": "number",
        "cover_art_hash": "any[]",
        "cover_art_s3_path": "any[]",
        "cover_art_type": "any[]",
        "created_at": "Date",
        "duration": "number",
        "ean": "string",
        "excluded_territory_codes": "any[]",
        "genre_name": "string",
        "grid": "string",
        "icpn": "string",
        "isrc": "string",
        "major_record_label_name": "string",
        "message_date": "Date",
        "parental_advisory": "string",
        "processed_date": "Date",
        "publishers": "any[]",
        "raw_ddex_ern_message": "RawDdexErnMessage",
        "raw_ddex_ern_message_id": "number",
        "raw_ddex_message_type": "RawDdexMessageType",
        "raw_ddex_message_type_id": "number",
        "raw_ddex_release_type": "RawDdexReleaseType",
        "raw_ddex_release_type_id": "number",
        "raw_ddex_track_takedown_status": "RawDdexTrackTakedownStatus",
        "raw_ddex_track_takedown_status_id": "number",
        "raw_ddex_tracks": "RawDdexTrack",
        "record_label_name": "string",
        "release_reference": "string",
        "release_resource_reference": "string",
        "release_type": "string",
        "resource_contributors": "any[]",
        "sub_genre_name": "string",
        "sub_title": "any[]",
        "territory_codes": "any[]",
        "title": "any[]",
        "upc": "string",
        "updated_at": "Date",
        "usage": "any[]",
        "validity_period": "any[]",
        "_nullable": [
            "title",
            "sub_title",
            "artists",
            "resource_contributors",
            "record_label_name",
            "major_record_label_name",
            "genre_name",
            "sub_genre_name",
            "duration",
            "copyright",
            "audio_file_s3_path",
            "audio_file_checksum",
            "bitrate",
            "publishers",
            "parental_advisory",
            "cover_art_s3_path",
            "cover_art_type",
            "cover_art_hash",
            "commercial_model_type",
            "usage",
            "validity_period",
            "territory_codes",
            "excluded_territory_codes",
            "album_artists",
            "album_name",
            "release_reference",
            "release_resource_reference",
            "isrc",
            "grid",
            "upc",
            "ean",
            "icpn",
            "catalog_number",
            "raw_ddex_track_takedown_status_id",
            "release_type",
            "raw_ddex_release_type_id",
            "message_date",
            "processed_date",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexTrackEchoprintState": {
        "id": "number",
        "codever": "string",
        "created_at": "Date",
        "failure_count": "number",
        "fingerprinted_at": "Date",
        "fp_code": "string",
        "match_attempted_at": "Date",
        "raw_ddex_track": "RawDdexTrack",
        "raw_ddex_track_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "fp_code",
            "codever",
            "fingerprinted_at",
            "match_attempted_at",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexTrackFingerprintMatch": {
        "id": "number",
        "confidence_score": "number",
        "created_at": "Date",
        "fingerprint_via": "string",
        "live_track": "LiveTrack",
        "live_track_code": "string",
        "live_track_id": "number",
        "raw_ddex_track": "RawDdexTrack",
        "raw_ddex_track_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "confidence_score",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexTrackTakedownStatus": {
        "id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RawDdexXmlFile": {
        "id": "number",
        "bucket": "string",
        "etag": "string",
        "processed_date": "Date",
        "raw_ddex_ern_messages": "RawDdexErnMessage",
        "s3_file_path": "string",
        "size": "number",
        "_nullable": [
            "processed_date"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RecordLayout": {
        "id": "number",
        "created_at": "Date",
        "definition": "any[]",
        "entity": "string",
        "owner_key": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "RefreshToken": {
        "id": "number",
        "expires_at": "Date",
        "replacedBy": "RefreshToken",
        "revoked_at": "Date",
        "user": "User",
        "_nullable": [
            "revoked_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Region": {
        "id": "number",
        "deleted_at": "Date",
        "_nullable": [
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "PerPlayCountryOandaExchangeRate": {
        "id": "number",
        "created_at": "Date",
        "rate": "number",
        "report_month": "Date",
        "_nullable": [
            "rate",
            "report_month",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayCountryRate": {
        "id": "number",
        "per_zone_minima": "number",
        "per_zone_minima_all_labels": "number",
        "record_label_id": "number",
        "_nullable": [
            "record_label_id",
            "per_zone_minima_all_labels",
            "per_zone_minima"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "PerPlayReportGenerationAttempt": {
        "id": "number",
        "datetime": "Date",
        "generation_number": "number",
        "report_type_id": "number",
        "_nullable": [
            "report_type_id",
            "generation_number",
            "datetime"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "RoyaltyImportProgress": {
        "id": "number",
        "batches_processed": "number",
        "bytes_processed": "number",
        "completed_at": "Date",
        "first_date": "Date",
        "job_id": "string",
        "last_date": "Date",
        "last_updated_at": "Date",
        "play_month": "string",
        "rows_deduplicated": "number",
        "rows_missing_track": "number",
        "rows_out_of_timeframe": "number",
        "rows_processed": "number",
        "rows_unprocessed_dropped": "number",
        "rows_written": "number",
        "s3_key": "string",
        "source_type": "string",
        "started_at": "Date",
        "total_bytes": "number",
        "total_lines": "number",
        "_nullable": [
            "job_id",
            "total_bytes",
            "total_lines",
            "first_date",
            "last_date",
            "started_at",
            "last_updated_at",
            "completed_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "SavedView": {
        "id": "number",
        "color": "string",
        "created_at": "Date",
        "definition": "any[]",
        "definition_version": "number",
        "entity": "string",
        "forkedFromSharedSavedView": "SharedSavedView",
        "forked_from_shared_saved_view_id": "number",
        "icon": "string",
        "name": "string",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "forked_from_shared_saved_view_id",
            "created_at",
            "updated_at",
            "icon",
            "color"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": []
    },
    "ScheduleHistory": {
        "id": "number",
        "action": "string",
        "after": "any[]",
        "before": "any[]",
        "created_at": "Date",
        "locationZone": "LocationZone",
        "location_zone_id": "number",
        "schedule": "LocationZoneCustomPlaylistSchedule",
        "schedule_id": "number",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "schedule_id",
            "location_zone_id",
            "before",
            "after",
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "SchedulingMode": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Account": {
        "id": "number",
        "_displayName": "'Account'",
        "_slug": "'account'",
        "account_manager_user": "User",
        "account_manager_user_id": "number",
        "account_status": "AccountStatus",
        "account_status_id": "number",
        "addresses": "Address",
        "can_skip": "boolean",
        "can_vote": "boolean",
        "categories": "Category",
        "client_user_ids": "any[]",
        "contacts": "Contact",
        "created_at": "Date",
        "deleted_at": "Date",
        "download_end_hour": "number",
        "download_start_hour": "number",
        "is_archived": "boolean",
        "is_onboarding": "boolean",
        "is_tpg_account": "boolean",
        "location_zones": "LocationZone[]",
        "locations": "Location[]",
        "name": "string",
        "onboarding_user": "User",
        "onboarding_user_id": "number",
        "phone_numbers": "PhoneNumber",
        "physical_address": "string",
        "playlist_manager_group": "PlaylistManagerGroup",
        "playlist_manager_group_id": "number",
        "tags": "Tag",
        "updated_at": "Date",
        "website_url": "string",
        "_nullable": [
            "is_tpg_account",
            "account_manager_user_id",
            "playlist_manager_group_id",
            "download_start_hour",
            "download_end_hour",
            "website_url",
            "onboarding_user_id",
            "deleted_at",
            "client_user_ids"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "account_status": "account_status.display_string",
            "account_manager_user": "account_manager_user.display_string",
            "playlist_manager_group": "playlist_manager_group.display_string",
            "onboarding_user": "onboarding_user.display_string",
            "tags": "tags.display_string",
            "locations": "locations.display_string",
            "location_zones": "location_zones.display_string",
            "addresses": "addresses.display_string",
            "phone_numbers": "phone_numbers.display_string",
            "contacts": "contacts.display_string",
            "categories": "categories.display_string"
        },
        "_frontendFields": {
            "physical_address": {
                "type": "string"
            }
        },
        "_childrenMappings": {
            "locations": "location",
            "location_zones": "location_zone",
            "tags": "tag",
            "addresses": "address",
            "phone_numbers": "phone_number",
            "contacts": "contact",
            "categories": "category"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "physical_address",
            "geo_location",
            "account_status",
            "can_vote",
            "created_at",
            "updated_at",
            "is_tpg_account",
            "can_skip",
            "account_manager_user_id",
            "account_manager_user",
            "playlist_manager_group_id",
            "playlist_manager_group",
            "download_start_hour",
            "download_end_hour",
            "website_url",
            "is_archived",
            "is_onboarding",
            "onboarding_user_id",
            "onboarding_user",
            "client_user_ids",
            "deleted_at",
            "tags",
            "locations",
            "location_zones",
            "addresses",
            "phone_numbers",
            "contacts",
            "categories"
        ],
        "_quickSearch": {
            "defaults": [
                "name"
            ],
            "offered": [
                {
                    "key": "account_manager_user.display_string",
                    "label": "Account manager user",
                    "kind": "text"
                },
                {
                    "key": "account_manager_user_id",
                    "label": "Account manager user id",
                    "kind": "number"
                },
                {
                    "key": "account_status.display_string",
                    "label": "Account status",
                    "kind": "text"
                },
                {
                    "key": "addresses.display_string",
                    "label": "Addresses",
                    "kind": "text"
                },
                {
                    "key": "categories.display_string",
                    "label": "Categories",
                    "kind": "text"
                },
                {
                    "key": "contacts.display_string",
                    "label": "Contacts",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "download_end_hour",
                    "label": "Download end hour",
                    "kind": "number"
                },
                {
                    "key": "download_start_hour",
                    "label": "Download start hour",
                    "kind": "number"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "location_zones.display_string",
                    "label": "Location zones",
                    "kind": "text"
                },
                {
                    "key": "locations.display_string",
                    "label": "Locations",
                    "kind": "text"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "onboarding_user.display_string",
                    "label": "Onboarding user",
                    "kind": "text"
                },
                {
                    "key": "onboarding_user_id",
                    "label": "Onboarding user id",
                    "kind": "number"
                },
                {
                    "key": "physical_address",
                    "label": "Physical address",
                    "kind": "text"
                },
                {
                    "key": "playlist_manager_group.display_string",
                    "label": "Playlist manager group",
                    "kind": "text"
                },
                {
                    "key": "playlist_manager_group_id",
                    "label": "Playlist manager group id",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "website_url",
                    "label": "Website url",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "short_name",
            "code",
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "account_status_id",
            "can_vote",
            "is_tpg_account",
            "can_skip",
            "account_manager_user_id",
            "playlist_manager_group_id",
            "website_url",
            "is_archived",
            "is_onboarding"
        ],
        "_unique": [
            "name",
            "website_url"
        ]
    },
    "Album": {
        "id": "number",
        "_displayName": "'Album'",
        "_slug": "'album'",
        "active": "boolean",
        "artist": "Artist",
        "artist_id": "number",
        "code": "string",
        "deleted_at": "Date",
        "genre": "Genre",
        "genre_id": "number",
        "name": "string",
        "record_label": "RecordLabel",
        "record_label_id": "number",
        "release_date": "Date",
        "tags": "Tag",
        "upc": "string",
        "_nullable": [
            "release_date",
            "upc",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "genre": "genre.display_string",
            "artist": "artist.display_string",
            "record_label": "record_label.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "release_date",
            "upc",
            "code",
            "genre_id",
            "genre",
            "artist_id",
            "artist",
            "record_label_id",
            "record_label",
            "active",
            "tags"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "artist.display_string",
                "upc"
            ],
            "offered": [
                {
                    "key": "artist.display_string",
                    "label": "Artist",
                    "kind": "text"
                },
                {
                    "key": "artist_id",
                    "label": "Artist id",
                    "kind": "number"
                },
                {
                    "key": "code",
                    "label": "Code",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "genre.display_string",
                    "label": "Genre",
                    "kind": "text"
                },
                {
                    "key": "genre_id",
                    "label": "Genre id",
                    "kind": "number"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "record_label.display_string",
                    "label": "Record label",
                    "kind": "text"
                },
                {
                    "key": "record_label_id",
                    "label": "Record label id",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "upc",
                    "label": "UPC",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "code"
        ],
        "_filled": [
            "name",
            "release_date",
            "upc",
            "genre_id",
            "artist_id",
            "record_label_id",
            "active"
        ],
        "_unique": [
            "name",
            "upc"
        ]
    },
    "Artist": {
        "id": "number",
        "_displayName": "'Artist'",
        "_slug": "'artist'",
        "active": "boolean",
        "albums": "Album[]",
        "aliases": "ArtistAlias[]",
        "deleted_at": "Date",
        "display_string": "string",
        "name": "string",
        "stream_only": "boolean",
        "tags": "Tag",
        "tracks": "LiveTrack[]",
        "_nullable": [
            "name",
            "stream_only",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "tags": "tags.display_string",
            "aliases": "aliases.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "albums": "album",
            "tracks": "live_track",
            "aliases": "artist_alias",
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "stream_only",
            "active",
            "tags",
            "created_at",
            "updated_at",
            "deleted_at",
            "aliases"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "aliases.display_string"
            ],
            "offered": [
                {
                    "key": "aliases.display_string",
                    "label": "Aliases",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [],
        "_filled": [
            "name",
            "active"
        ],
        "_unique": [
            "name"
        ]
    },
    "Bucket": {
        "id": "number",
        "_displayName": "'Bucket'",
        "_slug": "'bucket'",
        "account": "Account",
        "base_bucket": "Bucket",
        "base_bucket_id": "number",
        "base_bucket_zt_tracks": "Zt[]",
        "bucket_artist_excludes": "Artist[]",
        "bucket_artist_overrides": "BucketArtistOverride[]",
        "bucket_genres": "BucketGenre[]",
        "bucket_tag_excludes": "Tag[]",
        "bucket_tag_overrides": "BucketTagOverride[]",
        "bucket_track_excludes": "LiveTrack[]",
        "bucket_track_includes": "LiveTrack[]",
        "bucket_track_overrides": "BucketTrackOverride[]",
        "bucket_track_requests": "LiveTrack[]",
        "bucket_type_id": "number",
        "created_at": "Date",
        "deleted_at": "Date",
        "ignores_base_bucket_genres": "boolean",
        "is_archived": "boolean",
        "is_base_bucket": "boolean",
        "location": "Location",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "max_percentage_of_manual_tracks": "number",
        "min_percentage_of_preferred_tracks": "number",
        "name": "string",
        "short_description": "string",
        "sourced_custom_playlists": "LocationZoneCustomPlaylist[]",
        "tags": "Tag",
        "updated_at": "Date",
        "zt_tracks": "Zt[]",
        "_nullable": [
            "short_description",
            "location_zone_id",
            "created_at",
            "base_bucket_id",
            "bucket_type_id",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "location_zone": "location_zone.display_string",
            "location": "location.display_string",
            "account": "account.display_string",
            "base_bucket": "base_bucket.display_string",
            "bucket_genres": "bucket_genres.display_string",
            "bucket_tag_excludes": "bucket_tag_excludes.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "bucket_genres": "bucket_genre",
            "bucket_tag_excludes": "tag",
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "short_description",
            "location_zone_id",
            "location_zone",
            "location",
            "account",
            "max_percentage_of_manual_tracks",
            "is_base_bucket",
            "bucket_type_id",
            "bucket_type",
            "base_bucket_id",
            "base_bucket",
            "ignores_base_bucket_genres",
            "is_archived",
            "min_percentage_of_preferred_tracks",
            "created_at",
            "updated_at",
            "bucket_genres",
            "bucket_tag_excludes",
            "tags",
            "track_count",
            "track_count_counted_at"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "location_zone.display_string"
            ],
            "offered": [
                {
                    "key": "account.display_string",
                    "label": "Account",
                    "kind": "text"
                },
                {
                    "key": "base_bucket.display_string",
                    "label": "Base bucket",
                    "kind": "text"
                },
                {
                    "key": "base_bucket_id",
                    "label": "Base bucket id",
                    "kind": "number"
                },
                {
                    "key": "bucket_genres.display_string",
                    "label": "Bucket genres",
                    "kind": "text"
                },
                {
                    "key": "bucket_tag_excludes.display_string",
                    "label": "Bucket tag excludes",
                    "kind": "text"
                },
                {
                    "key": "bucket_type",
                    "label": "Bucket type",
                    "kind": "text"
                },
                {
                    "key": "bucket_type_id",
                    "label": "Bucket type id",
                    "kind": "number"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "location.display_string",
                    "label": "Location",
                    "kind": "text"
                },
                {
                    "key": "location_zone_id",
                    "label": "Location zone id",
                    "kind": "number"
                },
                {
                    "key": "max_percentage_of_manual_tracks",
                    "label": "Max percentage of manual tracks",
                    "kind": "number"
                },
                {
                    "key": "min_percentage_of_preferred_tracks",
                    "label": "Min percentage of preferred tracks",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "short_description",
                    "label": "Short description",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "track_count",
                    "label": "Track count",
                    "kind": "number"
                },
                {
                    "key": "location_zone.display_string",
                    "label": "Zone",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [],
        "_filled": [
            "name",
            "short_description",
            "location_zone_id",
            "max_percentage_of_manual_tracks",
            "is_base_bucket",
            "base_bucket_id",
            "ignores_base_bucket_genres",
            "is_archived",
            "min_percentage_of_preferred_tracks"
        ],
        "_unique": []
    },
    "Contact": {
        "id": "number",
        "_displayName": "'Contact'",
        "_slug": "'contact'",
        "brand": "Brand",
        "brand_id": "number",
        "categories": "Category",
        "client_user_ids": "any[]",
        "created_at": "Date",
        "cw_link_sent": "boolean",
        "cw_link_sent_date": "Date",
        "cw_link_sent_user": "User",
        "cw_link_sent_user_id": "number",
        "email": "string",
        "first_name": "string",
        "instore_location_zone": "LocationZone",
        "instore_location_zone_id": "number",
        "is_archived": "boolean",
        "is_tpg_contact": "boolean",
        "last_name": "string",
        "owners": "Contactable[]",
        "tags": "Tag",
        "temporary_instore_expiration": "Date",
        "title": "string",
        "updated_at": "Date",
        "votes_count": "number",
        "_nullable": [
            "first_name",
            "last_name",
            "created_at",
            "is_tpg_contact",
            "brand_id",
            "title",
            "cw_link_sent_date",
            "cw_link_sent_user_id",
            "instore_location_zone_id",
            "temporary_instore_expiration",
            "client_user_ids"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "cw_link_sent_user": "cw_link_sent_user.display_string",
            "instore_location_zone": "instore_location_zone.display_string",
            "brand": "brand.display_string",
            "tags": "tags.display_string",
            "categories": "categories.display_string",
            "owners": "owners.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag",
            "categories": "category"
        },
        "_searchable": [
            "id",
            "display_string",
            "first_name",
            "last_name",
            "email",
            "created_at",
            "updated_at",
            "is_tpg_contact",
            "is_archived",
            "brand_id",
            "title",
            "cw_link_sent",
            "cw_link_sent_date",
            "cw_link_sent_user_id",
            "instore_location_zone_id",
            "votes_count",
            "temporary_instore_expiration",
            "client_user_ids",
            "cw_link_sent_user",
            "instore_location_zone",
            "brand",
            "tags",
            "categories",
            "owners"
        ],
        "_quickSearch": {
            "defaults": [
                "display_string",
                "first_name",
                "last_name",
                "email"
            ],
            "offered": [
                {
                    "key": "brand.display_string",
                    "label": "Brand",
                    "kind": "text"
                },
                {
                    "key": "brand_id",
                    "label": "Brand id",
                    "kind": "number"
                },
                {
                    "key": "categories.display_string",
                    "label": "Categories",
                    "kind": "text"
                },
                {
                    "key": "cw_link_sent_user.display_string",
                    "label": "Cw link sent user",
                    "kind": "text"
                },
                {
                    "key": "cw_link_sent_user_id",
                    "label": "Cw link sent user id",
                    "kind": "number"
                },
                {
                    "key": "email",
                    "label": "Email",
                    "kind": "text"
                },
                {
                    "key": "first_name",
                    "label": "First name",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "instore_location_zone.display_string",
                    "label": "Instore location zone",
                    "kind": "text"
                },
                {
                    "key": "instore_location_zone_id",
                    "label": "Instore location zone id",
                    "kind": "number"
                },
                {
                    "key": "last_name",
                    "label": "Last name",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "owners.display_string",
                    "label": "Owners",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "title",
                    "label": "Title",
                    "kind": "text"
                },
                {
                    "key": "votes_count",
                    "label": "Votes count",
                    "kind": "number"
                }
            ]
        },
        "_prohibited": [
            "created_at",
            "updated_at",
            "cw_link_sent",
            "cw_link_sent_date",
            "cw_link_sent_user_id"
        ],
        "_filled": [
            "first_name",
            "last_name",
            "email",
            "is_tpg_contact",
            "is_archived",
            "brand_id",
            "instore_location_zone_id",
            "votes_count",
            "temporary_instore_expiration"
        ],
        "_unique": [
            "email"
        ]
    },
    "ContactLoginCustomPlaylist": {
        "id": "number",
        "_displayName": "'Contact Custom Playlist'",
        "_slug": "'contact_custom_playlist'",
        "client_user_ids": "any[]",
        "contact_login": "ContactLogin",
        "contact_login_custom_playlist_tracks": "ContactLoginCustomPlaylistTrack[]",
        "contact_login_id": "number",
        "created_at": "Date",
        "created_by_user": "User",
        "created_by_user_id": "number",
        "is_archived": "boolean",
        "name": "string",
        "tags": "Tag",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "client_user_ids"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "contact_login": "contact_login.display_string",
            "created_by_user": "created_by_user.display_string",
            "contact_login_custom_playlist_tracks": "contact_login_custom_playlist_tracks.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "contact_login_id",
            "contact_login",
            "created_by_user_id",
            "created_by_user",
            "created_at",
            "updated_at",
            "is_archived",
            "client_user_ids",
            "contact_login_custom_playlist_tracks",
            "tags"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "contact_login.display_string"
            ],
            "offered": [
                {
                    "key": "contact_login_custom_playlist_tracks.display_string",
                    "label": "Contact login custom playlist tracks",
                    "kind": "text"
                },
                {
                    "key": "contact_login_id",
                    "label": "Contact login id",
                    "kind": "number"
                },
                {
                    "key": "created_by_user.display_string",
                    "label": "Created by user",
                    "kind": "text"
                },
                {
                    "key": "created_by_user_id",
                    "label": "Created by user id",
                    "kind": "number"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "contact_login.display_string",
                    "label": "Owner",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [],
        "_filled": [
            "is_archived"
        ],
        "_unique": []
    },
    "ContactLoginStation": {
        "id": "number",
        "_displayName": "'Station'",
        "_slug": "'contact_login_station'",
        "all_tracks_voted_off": "boolean",
        "allow_subscriber_customization": "boolean",
        "client_user_ids": "any[]",
        "clientweb_interactive": "boolean",
        "clientweb_published": "boolean",
        "clientweb_shuffle": "boolean",
        "clientweb_voting": "boolean",
        "code": "string",
        "contact": "Contact",
        "contact_login": "ContactLogin",
        "contact_login_id": "number",
        "contact_login_station_source": "ContactLoginCustomPlaylist | LocationZone | LocationZoneCustomPlaylist",
        "contact_login_station_source_id": "number",
        "contact_login_station_source_table_name": "string",
        "contact_login_station_source_type": "ContactLoginStationSourceType",
        "contact_login_station_source_type_id": "number",
        "created_at": "Date",
        "expiration": "Date",
        "geo_allowed_cities": "string",
        "geo_allowed_countries": "string",
        "is_broken": "boolean",
        "is_review_station": "boolean",
        "is_tpg_link": "boolean",
        "master_contact_login_station": "ContactLoginStation",
        "master_contact_login_station_id": "number",
        "mobile_published": "boolean",
        "mobile_sample": "boolean",
        "mobile_shuffle": "boolean",
        "name": "string",
        "playlist_offset": "number",
        "short_clip_playback_type": "ShortClipPlaybackType",
        "short_clip_playback_type_id": "number",
        "short_clips": "boolean",
        "should_expire": "boolean",
        "should_show_track_info": "boolean",
        "shuffle_seed": "number",
        "tags": "Tag",
        "time_zone": "TimeZone",
        "time_zone_id": "number",
        "updated_at": "Date",
        "vote_destination_location_zone": "LocationZone",
        "vote_destination_location_zone_id": "number",
        "web_geo_ip": "boolean",
        "web_interactive": "boolean",
        "web_logging": "boolean",
        "web_login_disabled": "boolean",
        "web_published": "boolean",
        "web_sample": "boolean",
        "web_should_loop": "boolean",
        "web_shuffle": "boolean",
        "_nullable": [
            "contact_login_station_source_id",
            "contact_login_station_source_type_id",
            "contact_login_station_source_table_name",
            "vote_destination_location_zone_id",
            "expiration",
            "is_review_station",
            "short_clips",
            "short_clip_playback_type_id",
            "clientweb_published",
            "clientweb_shuffle",
            "clientweb_interactive",
            "clientweb_voting",
            "mobile_published",
            "mobile_shuffle",
            "mobile_sample",
            "web_published",
            "web_geo_ip",
            "geo_allowed_countries",
            "geo_allowed_cities",
            "web_shuffle",
            "web_sample",
            "web_interactive",
            "is_tpg_link",
            "client_user_ids",
            "created_at",
            "updated_at",
            "playlist_offset",
            "is_broken",
            "shuffle_seed",
            "all_tracks_voted_off",
            "master_contact_login_station_id",
            "web_logging"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "contact_login_station_source_type": "contact_login_station_source_type.display_string",
            "contact": "contact.display_string",
            "contact_login": "contact_login.display_string",
            "short_clip_playback_type": "short_clip_playback_type.display_string",
            "time_zone": "time_zone.display_string",
            "vote_destination_location_zone": "vote_destination_location_zone.display_string",
            "master_contact_login_station": "master_contact_login_station.display_string",
            "tags": "tags.display_string",
            "contact_login_station_source": "contact_login_station_source.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "contact_login_id",
            "contact_login_station_source_id",
            "contact_login_station_source_type_id",
            "contact_login_station_source_table_name",
            "vote_destination_location_zone_id",
            "should_expire",
            "expiration",
            "time_zone_id",
            "is_review_station",
            "short_clips",
            "short_clip_playback_type_id",
            "clientweb_published",
            "clientweb_shuffle",
            "clientweb_interactive",
            "clientweb_voting",
            "mobile_published",
            "mobile_shuffle",
            "mobile_sample",
            "web_published",
            "web_geo_ip",
            "geo_allowed_countries",
            "geo_allowed_cities",
            "web_shuffle",
            "web_sample",
            "web_interactive",
            "web_should_loop",
            "web_login_disabled",
            "should_show_track_info",
            "is_tpg_link",
            "code",
            "client_user_ids",
            "created_at",
            "updated_at",
            "playlist_offset",
            "is_broken",
            "shuffle_seed",
            "all_tracks_voted_off",
            "master_contact_login_station_id",
            "allow_subscriber_customization",
            "web_logging",
            "contact_login_station_source_type",
            "contact",
            "contact_login",
            "short_clip_playback_type",
            "time_zone",
            "vote_destination_location_zone",
            "master_contact_login_station",
            "tags",
            "contact_login_station_source"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "code",
                "contact_login.display_string"
            ],
            "offered": [
                {
                    "key": "code",
                    "label": "Code",
                    "kind": "text"
                },
                {
                    "key": "contact.display_string",
                    "label": "Contact",
                    "kind": "text"
                },
                {
                    "key": "contact_login_id",
                    "label": "Contact login id",
                    "kind": "number"
                },
                {
                    "key": "contact_login_station_source.display_string",
                    "label": "Contact login station source",
                    "kind": "text"
                },
                {
                    "key": "contact_login_station_source_id",
                    "label": "Contact login station source id",
                    "kind": "number"
                },
                {
                    "key": "contact_login_station_source_table_name",
                    "label": "Contact login station source table name",
                    "kind": "text"
                },
                {
                    "key": "contact_login_station_source_type.display_string",
                    "label": "Contact login station source type",
                    "kind": "text"
                },
                {
                    "key": "contact_login_station_source_type_id",
                    "label": "Contact login station source type id",
                    "kind": "number"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "geo_allowed_cities",
                    "label": "Geo allowed cities",
                    "kind": "text"
                },
                {
                    "key": "geo_allowed_countries",
                    "label": "Geo allowed countries",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "master_contact_login_station.display_string",
                    "label": "Master contact login station",
                    "kind": "text"
                },
                {
                    "key": "master_contact_login_station_id",
                    "label": "Master contact login station id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "contact_login.display_string",
                    "label": "Owner",
                    "kind": "text"
                },
                {
                    "key": "playlist_offset",
                    "label": "Playlist offset",
                    "kind": "number"
                },
                {
                    "key": "short_clip_playback_type.display_string",
                    "label": "Short clip playback type",
                    "kind": "text"
                },
                {
                    "key": "short_clip_playback_type_id",
                    "label": "Short clip playback type id",
                    "kind": "number"
                },
                {
                    "key": "shuffle_seed",
                    "label": "Shuffle seed",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "time_zone.display_string",
                    "label": "Time zone",
                    "kind": "text"
                },
                {
                    "key": "time_zone_id",
                    "label": "Time zone id",
                    "kind": "number"
                },
                {
                    "key": "vote_destination_location_zone.display_string",
                    "label": "Vote destination location zone",
                    "kind": "text"
                },
                {
                    "key": "vote_destination_location_zone_id",
                    "label": "Vote destination location zone id",
                    "kind": "number"
                }
            ]
        },
        "_prohibited": [
            "created_at",
            "updated_at",
            "shuffle_seed"
        ],
        "_filled": [
            "name",
            "contact_login_id",
            "contact_login_station_source_id",
            "contact_login_station_source_type_id",
            "contact_login_station_source_table_name",
            "vote_destination_location_zone_id",
            "should_expire",
            "expiration",
            "time_zone_id",
            "is_review_station",
            "short_clips",
            "short_clip_playback_type_id",
            "clientweb_published",
            "clientweb_shuffle",
            "clientweb_interactive",
            "clientweb_voting",
            "mobile_published",
            "mobile_shuffle",
            "mobile_sample",
            "web_published",
            "web_geo_ip",
            "web_shuffle",
            "web_sample",
            "web_interactive",
            "web_should_loop",
            "web_login_disabled",
            "should_show_track_info",
            "is_tpg_link",
            "code",
            "playlist_offset",
            "is_broken",
            "all_tracks_voted_off",
            "master_contact_login_station_id",
            "allow_subscriber_customization",
            "web_logging"
        ],
        "_unique": []
    },
    "LiveTrack": {
        "id": "number",
        "_displayName": "'Live Track'",
        "_slug": "'live_track'",
        "active": "boolean",
        "album": "Album",
        "album_id": "number",
        "artist": "Artist",
        "artist_id": "number",
        "bitrate": "number",
        "catalog_code": "string",
        "code": "string",
        "copyright": "number",
        "cover_art_s3_path": "string",
        "cover_art_signed_url": "string",
        "cover_art_updated_at": "Date",
        "created_at": "Date",
        "did_check_lyrics": "boolean",
        "disabled_reason": "string",
        "does_have_tasting_note": "boolean",
        "duration": "number",
        "fade_in_duration": "number",
        "fade_in_start": "number",
        "fade_out_duration": "number",
        "fade_out_start": "number",
        "file_updated_at": "Date",
        "genre": "Genre",
        "genre_id": "number",
        "is_in_use": "number",
        "is_sound_exchange": "boolean",
        "isrc": "string",
        "latest_live_track_action": "LiveTrackAction",
        "latest_live_track_action_id": "number",
        "live_track_deals": "LiveTrackDeal[]",
        "live_track_echoprint_state": "LiveTrackEchoprintState",
        "live_track_matches": "LiveTrackMatch[]",
        "lyrics": "TrackLyrics",
        "lyrics_check_status": "LyricsCheckStatus",
        "lyrics_check_status_id": "number",
        "lyrics_check_status_updated_at": "Date",
        "lyrics_check_status_updated_by_user": "User",
        "lyrics_check_status_updated_by_user_id": "number",
        "match_sender_party_ids": "any[]",
        "match_sent_on_behalf_of_party_ids": "any[]",
        "name": "string",
        "normalized_level": "number",
        "original_duration": "number",
        "parental_advisory_type": "ParentalAdvisoryType",
        "parental_advisory_type_id": "number",
        "playlist_count": "number",
        "playlist_usages": "PlaylistTrack[]",
        "rating": "string",
        "raw_ddex_record_label_name": "string",
        "raw_ddex_root_record_label_name": "string",
        "raw_ddex_root_record_label_party": "RawDdexParty",
        "raw_ddex_root_record_label_party_id": "number",
        "raw_ddex_track": "RawDdexTrack",
        "raw_ddex_track_id": "number",
        "record_label": "RecordLabel",
        "record_label_id": "number",
        "remix_name": "string",
        "remix_source_track": "LiveTrack",
        "remix_source_track_id": "number",
        "requested_for_user": "User",
        "requested_for_user_id": "number",
        "staged_track_source": "StagedTrackSource",
        "staged_track_source_id": "number",
        "tags": "Tag",
        "track_match_status": "TrackMatchStatus",
        "track_match_status_id": "number",
        "track_match_types": "any[]",
        "updated_at": "Date",
        "uploaded_date": "Date",
        "_nullable": [
            "name",
            "code",
            "duration",
            "original_duration",
            "raw_ddex_track_id",
            "latest_live_track_action_id",
            "isrc",
            "remix_name",
            "remix_source_track_id",
            "created_at",
            "copyright",
            "disabled_reason",
            "requested_for_user_id",
            "uploaded_date",
            "does_have_tasting_note",
            "lyrics_check_status_id",
            "lyrics_check_status_updated_at",
            "lyrics_check_status_updated_by_user_id",
            "catalog_code",
            "staged_track_source_id",
            "bitrate",
            "parental_advisory_type_id",
            "rating",
            "track_match_types",
            "match_sender_party_ids",
            "match_sent_on_behalf_of_party_ids",
            "cover_art_s3_path",
            "cover_art_signed_url",
            "file_updated_at",
            "cover_art_updated_at"
        ],
        "_columnNameMappings": {
            "name": "title",
            "remix_name": "remix",
            "match_sender_party_ids": "match_sender_party",
            "match_sent_on_behalf_of_party_ids": "match_sent_on_behalf_of_party"
        },
        "_filterFieldMappings": {
            "latest_live_track_action": "latest_live_track_action.display_string",
            "artist": "artist.display_string",
            "album": "album.display_string",
            "genre": "genre.display_string",
            "record_label": "record_label.display_string",
            "remix_source_track": "remix_source_track.display_string",
            "requested_for_user": "requested_for_user.display_string",
            "lyrics_check_status": "lyrics_check_status.display_string",
            "lyrics_check_status_updated_by_user": "lyrics_check_status_updated_by_user.display_string",
            "staged_track_source": "staged_track_source.display_string",
            "parental_advisory_type": "parental_advisory_type.display_string",
            "track_match_status": "track_match_status.display_string",
            "live_track_echoprint_state": "live_track_echoprint_state.display_string",
            "raw_ddex_root_record_label_party": "raw_ddex_root_record_label_party.display_string",
            "raw_ddex_track": "raw_ddex_track.display_string",
            "live_track_matches": "live_track_matches.display_string",
            "tags": "tags.display_string",
            "playlist_usages": "playlist_usages.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "live_track_matches": "live_track_match",
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "code",
            "duration",
            "original_duration",
            "raw_ddex_track_id",
            "raw_ddex_record_label_name",
            "raw_ddex_root_record_label_name",
            "raw_ddex_root_record_label_party_id",
            "latest_live_track_action_id",
            "latest_live_track_action",
            "artist_id",
            "artist",
            "album_id",
            "album",
            "genre_id",
            "genre",
            "record_label_id",
            "record_label",
            "isrc",
            "remix_name",
            "remix_source_track_id",
            "remix_source_track",
            "created_at",
            "updated_at",
            "copyright",
            "is_in_use",
            "playlist_count",
            "active",
            "disabled_reason",
            "requested_for_user_id",
            "requested_for_user",
            "normalized_level",
            "has_fade",
            "fade_in_start",
            "fade_in_duration",
            "fade_out_start",
            "fade_out_duration",
            "uploaded_date",
            "duration_string",
            "does_have_tasting_note",
            "is_sound_exchange",
            "did_check_lyrics",
            "lyrics_check_status_id",
            "lyrics_check_status",
            "lyrics_check_status_updated_at",
            "lyrics_check_status_updated_by_user_id",
            "lyrics_check_status_updated_by_user",
            "catalog_code",
            "staged_track_source_id",
            "staged_track_source",
            "bitrate",
            "parental_advisory_type_id",
            "parental_advisory_type",
            "rating",
            "cover_art_s3_path",
            "cover_art_signed_url",
            "file_updated_at",
            "cover_art_updated_at",
            "track_match_status_id",
            "track_match_status",
            "live_track_echoprint_state",
            "raw_ddex_root_record_label_party",
            "raw_ddex_track",
            "track_match_types",
            "match_sender_party_ids",
            "match_sent_on_behalf_of_party_ids",
            "live_track_matches",
            "tags",
            "playlist_usages"
        ],
        "_quickSearch": {
            "defaults": [
                "display_string",
                "artist.display_string",
                "isrc",
                "code"
            ],
            "offered": [
                {
                    "key": "album.display_string",
                    "label": "Album",
                    "kind": "text"
                },
                {
                    "key": "album_id",
                    "label": "Album id",
                    "kind": "number"
                },
                {
                    "key": "artist.display_string",
                    "label": "Artist",
                    "kind": "text"
                },
                {
                    "key": "artist_id",
                    "label": "Artist id",
                    "kind": "number"
                },
                {
                    "key": "bitrate",
                    "label": "Bitrate",
                    "kind": "number"
                },
                {
                    "key": "catalog_code",
                    "label": "Catalog code",
                    "kind": "text"
                },
                {
                    "key": "code",
                    "label": "Code",
                    "kind": "text"
                },
                {
                    "key": "copyright",
                    "label": "Copyright",
                    "kind": "number"
                },
                {
                    "key": "cover_art_s3_path",
                    "label": "Cover art s3 path",
                    "kind": "text"
                },
                {
                    "key": "cover_art_signed_url",
                    "label": "Cover art signed url",
                    "kind": "text"
                },
                {
                    "key": "disabled_reason",
                    "label": "Disabled reason",
                    "kind": "text"
                },
                {
                    "key": "duration",
                    "label": "Duration",
                    "kind": "number"
                },
                {
                    "key": "duration_string",
                    "label": "Duration string",
                    "kind": "text"
                },
                {
                    "key": "genre.display_string",
                    "label": "Genre",
                    "kind": "text"
                },
                {
                    "key": "genre_id",
                    "label": "Genre id",
                    "kind": "number"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "is_in_use",
                    "label": "Is in use",
                    "kind": "number"
                },
                {
                    "key": "isrc",
                    "label": "ISRC",
                    "kind": "text"
                },
                {
                    "key": "latest_live_track_action.display_string",
                    "label": "Latest live track action",
                    "kind": "text"
                },
                {
                    "key": "latest_live_track_action_id",
                    "label": "Latest live track action id",
                    "kind": "number"
                },
                {
                    "key": "live_track_echoprint_state.display_string",
                    "label": "Live track echoprint state",
                    "kind": "text"
                },
                {
                    "key": "live_track_matches.display_string",
                    "label": "Live track matches",
                    "kind": "text"
                },
                {
                    "key": "lyrics_check_status.display_string",
                    "label": "Lyrics check status",
                    "kind": "text"
                },
                {
                    "key": "lyrics_check_status_id",
                    "label": "Lyrics check status id",
                    "kind": "number"
                },
                {
                    "key": "lyrics_check_status_updated_by_user.display_string",
                    "label": "Lyrics check status updated by user",
                    "kind": "text"
                },
                {
                    "key": "lyrics_check_status_updated_by_user_id",
                    "label": "Lyrics check status updated by user id",
                    "kind": "number"
                },
                {
                    "key": "display_string",
                    "label": "Name with remix",
                    "kind": "text"
                },
                {
                    "key": "normalized_level",
                    "label": "Normalized level",
                    "kind": "number"
                },
                {
                    "key": "original_duration",
                    "label": "Original duration",
                    "kind": "number"
                },
                {
                    "key": "parental_advisory_type.display_string",
                    "label": "Parental advisory type",
                    "kind": "text"
                },
                {
                    "key": "parental_advisory_type_id",
                    "label": "Parental advisory type id",
                    "kind": "number"
                },
                {
                    "key": "playlist_count",
                    "label": "Playlist count",
                    "kind": "number"
                },
                {
                    "key": "playlist_usages.display_string",
                    "label": "Playlist usages",
                    "kind": "text"
                },
                {
                    "key": "rating",
                    "label": "Rating",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_record_label_name",
                    "label": "Raw ddex record label name",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_root_record_label_name",
                    "label": "Raw ddex root record label name",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_root_record_label_party.display_string",
                    "label": "Raw ddex root record label party",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_root_record_label_party_id",
                    "label": "Raw ddex root record label party id",
                    "kind": "number"
                },
                {
                    "key": "raw_ddex_track.display_string",
                    "label": "Raw ddex track",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_track_id",
                    "label": "Raw ddex track id",
                    "kind": "number"
                },
                {
                    "key": "record_label.display_string",
                    "label": "Record label",
                    "kind": "text"
                },
                {
                    "key": "record_label_id",
                    "label": "Record label id",
                    "kind": "number"
                },
                {
                    "key": "remix_name",
                    "label": "Remix",
                    "kind": "text"
                },
                {
                    "key": "remix_source_track.display_string",
                    "label": "Remix source track",
                    "kind": "text"
                },
                {
                    "key": "remix_source_track_id",
                    "label": "Remix source track id",
                    "kind": "number"
                },
                {
                    "key": "requested_for_user.display_string",
                    "label": "Requested for user",
                    "kind": "text"
                },
                {
                    "key": "requested_for_user_id",
                    "label": "Requested for user id",
                    "kind": "number"
                },
                {
                    "key": "staged_track_source.display_string",
                    "label": "Staged track source",
                    "kind": "text"
                },
                {
                    "key": "staged_track_source_id",
                    "label": "Staged track source id",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "name",
                    "label": "Title",
                    "kind": "text"
                },
                {
                    "key": "track_match_status.display_string",
                    "label": "Track match status",
                    "kind": "text"
                },
                {
                    "key": "track_match_status_id",
                    "label": "Track match status id",
                    "kind": "number"
                },
                {
                    "key": "track_match_types",
                    "label": "Track match types",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "code",
            "raw_ddex_record_label_name",
            "raw_ddex_root_record_label_name",
            "raw_ddex_root_record_label_party_id",
            "normalized_level",
            "track_match_status_id",
            "track_match_types",
            "track_match_types.*"
        ],
        "_filled": [
            "name",
            "duration",
            "original_duration",
            "artist_id",
            "album_id",
            "genre_id",
            "record_label_id",
            "isrc",
            "copyright",
            "active",
            "disabled_reason",
            "requested_for_user_id",
            "fade_in_start",
            "fade_in_duration",
            "fade_out_start",
            "fade_out_duration",
            "uploaded_date",
            "duration_string",
            "does_have_tasting_note",
            "is_sound_exchange",
            "did_check_lyrics",
            "lyrics_check_status_id",
            "lyrics_check_status_updated_at",
            "lyrics_check_status_updated_by_user_id",
            "catalog_code",
            "staged_track_source_id",
            "bitrate",
            "parental_advisory_type_id",
            "rating"
        ],
        "_unique": []
    },
    "LiveTrackAction": {
        "id": "number",
        "_displayName": "'Live Track Action'",
        "_slug": "'live_track_action'",
        "audio_file_completed_at": "Date",
        "can_retry": "boolean",
        "cover_art_completed_at": "Date",
        "created_at": "Date",
        "deleted_at": "Date",
        "encoded_audio_fields": "any[]",
        "error_messages": "string",
        "live_track": "LiveTrack",
        "live_track_action_status": "LiveTrackActionStatus",
        "live_track_action_status_id": "number",
        "live_track_backup": "any[]",
        "live_track_code": "string",
        "live_track_id": "number",
        "metadata_completed_at": "Date",
        "performed_by_user": "User",
        "performed_by_user_id": "number",
        "raw_ddex_track": "RawDdexTrack",
        "raw_ddex_track_id": "number",
        "rollback_to_action": "LiveTrackAction",
        "rollback_to_action_id": "number",
        "source": "string",
        "tags": "Tag",
        "update_audio_file": "string",
        "update_cover_art": "string",
        "update_fields": "any[]",
        "updated_at": "Date",
        "verify_files_before_update": "boolean",
        "_nullable": [
            "performed_by_user_id",
            "live_track_id",
            "live_track_code",
            "raw_ddex_track_id",
            "source",
            "update_audio_file",
            "update_cover_art",
            "update_fields",
            "live_track_backup",
            "encoded_audio_fields",
            "audio_file_completed_at",
            "cover_art_completed_at",
            "metadata_completed_at",
            "rollback_to_action_id",
            "live_track_action_status_id",
            "error_messages",
            "created_at",
            "updated_at",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "performed_by_user": "performed_by_user.display_string",
            "live_track": "live_track.display_string",
            "live_track_action_status": "live_track_action_status.display_string",
            "raw_ddex_track": "raw_ddex_track.display_string",
            "rollback_to_action": "rollback_to_action.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "performed_by_user_id",
            "performed_by_user",
            "live_track_id",
            "raw_ddex_track_id",
            "live_track_code",
            "live_track",
            "live_track_action_status",
            "raw_ddex_track",
            "rollback_to_action",
            "source",
            "update_audio_file",
            "update_cover_art",
            "update_fields",
            "live_track_backup",
            "encoded_audio_fields",
            "audio_file_completed_at",
            "cover_art_completed_at",
            "metadata_completed_at",
            "verify_files_before_update",
            "rollback_to_action_id",
            "live_track_action_status_id",
            "error_messages",
            "created_at",
            "updated_at",
            "deleted_at",
            "tags"
        ],
        "_quickSearch": {
            "defaults": [
                "live_track.display_string",
                "live_track_code"
            ],
            "offered": [
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "live_track_action_status.display_string",
                    "label": "Live track action status",
                    "kind": "text"
                },
                {
                    "key": "live_track_action_status_id",
                    "label": "Live track action status id",
                    "kind": "number"
                },
                {
                    "key": "live_track_id",
                    "label": "Live track id",
                    "kind": "number"
                },
                {
                    "key": "performed_by_user.display_string",
                    "label": "Performed by user",
                    "kind": "text"
                },
                {
                    "key": "performed_by_user_id",
                    "label": "Performed by user id",
                    "kind": "number"
                },
                {
                    "key": "raw_ddex_track.display_string",
                    "label": "Raw ddex track",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_track_id",
                    "label": "Raw ddex track id",
                    "kind": "number"
                },
                {
                    "key": "rollback_to_action.display_string",
                    "label": "Rollback to action",
                    "kind": "text"
                },
                {
                    "key": "rollback_to_action_id",
                    "label": "Rollback to action id",
                    "kind": "number"
                },
                {
                    "key": "source",
                    "label": "Source",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "live_track.display_string",
                    "label": "Track",
                    "kind": "text"
                },
                {
                    "key": "live_track_code",
                    "label": "Track code",
                    "kind": "text"
                },
                {
                    "key": "update_audio_file",
                    "label": "Update audio file",
                    "kind": "text"
                },
                {
                    "key": "update_cover_art",
                    "label": "Update cover art",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "live_track_action_status_id",
            "performed_by_user_id",
            "error_messages",
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "live_track_id",
            "live_track_code",
            "source"
        ],
        "_unique": []
    },
    "Location": {
        "id": "number",
        "_displayName": "'Location'",
        "_slug": "'location'",
        "account": "Account",
        "account_id": "number",
        "addresses": "Address",
        "already_open": "boolean",
        "alt_store_number": "string",
        "categories": "Category",
        "category": "Category",
        "category_id": "number",
        "client_user_ids": "any[]",
        "contacts": "Contact",
        "deleted_at": "Date",
        "franchisee": "Location",
        "franchisee_id": "number",
        "is_archived": "boolean",
        "is_music_zone_holder": "boolean",
        "is_onboarding": "boolean",
        "location_status": "LocationStatus",
        "location_status_id": "number",
        "location_zones": "LocationZone[]",
        "name": "string",
        "onboarding_user": "User",
        "onboarding_user_id": "number",
        "phone_numbers": "PhoneNumber",
        "physical_address": "string",
        "region": "Region",
        "region_id": "number",
        "startup_date": "Date",
        "store_number": "string",
        "tags": "Tag",
        "website_url": "string",
        "_nullable": [
            "startup_date",
            "store_number",
            "alt_store_number",
            "franchisee_id",
            "website_url",
            "onboarding_user_id",
            "deleted_at",
            "client_user_ids"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "account": "account.display_string",
            "category": "category.display_string",
            "location_status": "location_status.display_string",
            "region": "region.display_string",
            "franchisee": "franchisee.display_string",
            "onboarding_user": "onboarding_user.display_string",
            "tags": "tags.display_string",
            "addresses": "addresses.display_string",
            "phone_numbers": "phone_numbers.display_string",
            "contacts": "contacts.display_string",
            "categories": "categories.display_string",
            "location_zones": "location_zones.display_string"
        },
        "_frontendFields": {
            "physical_address": {
                "type": "string"
            }
        },
        "_childrenMappings": {
            "location_zones": "location_zone",
            "tags": "tag",
            "addresses": "address",
            "phone_numbers": "phone_number",
            "contacts": "contact",
            "categories": "category"
        },
        "_searchable": [
            "id",
            "display_string",
            "account_id",
            "account",
            "name",
            "category_id",
            "category",
            "startup_date",
            "location_status_id",
            "location_status",
            "region_id",
            "region",
            "store_number",
            "alt_store_number",
            "physical_address",
            "geo_location",
            "franchisee_id",
            "franchisee",
            "is_archived",
            "is_onboarding",
            "onboarding_user_id",
            "onboarding_user",
            "already_open",
            "client_user_ids",
            "tags",
            "addresses",
            "phone_numbers",
            "contacts",
            "categories",
            "location_zones"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "account.display_string",
                "store_number"
            ],
            "offered": [
                {
                    "key": "account.display_string",
                    "label": "Account",
                    "kind": "text"
                },
                {
                    "key": "account_id",
                    "label": "Account id",
                    "kind": "number"
                },
                {
                    "key": "addresses.display_string",
                    "label": "Addresses",
                    "kind": "text"
                },
                {
                    "key": "alt_store_number",
                    "label": "Alt store number",
                    "kind": "text"
                },
                {
                    "key": "categories.display_string",
                    "label": "Categories",
                    "kind": "text"
                },
                {
                    "key": "category.display_string",
                    "label": "Category",
                    "kind": "text"
                },
                {
                    "key": "category_id",
                    "label": "Category id",
                    "kind": "number"
                },
                {
                    "key": "contacts.display_string",
                    "label": "Contacts",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "franchisee.display_string",
                    "label": "Franchisee",
                    "kind": "text"
                },
                {
                    "key": "franchisee_id",
                    "label": "Franchisee id",
                    "kind": "number"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "location_status.display_string",
                    "label": "Location status",
                    "kind": "text"
                },
                {
                    "key": "location_status_id",
                    "label": "Location status id",
                    "kind": "number"
                },
                {
                    "key": "location_zones.display_string",
                    "label": "Location zones",
                    "kind": "text"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "onboarding_user.display_string",
                    "label": "Onboarding user",
                    "kind": "text"
                },
                {
                    "key": "onboarding_user_id",
                    "label": "Onboarding user id",
                    "kind": "number"
                },
                {
                    "key": "phone_numbers.display_string",
                    "label": "Phone numbers",
                    "kind": "text"
                },
                {
                    "key": "physical_address",
                    "label": "Physical address",
                    "kind": "text"
                },
                {
                    "key": "region.display_string",
                    "label": "Region",
                    "kind": "text"
                },
                {
                    "key": "region_id",
                    "label": "Region id",
                    "kind": "number"
                },
                {
                    "key": "store_number",
                    "label": "Store number",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "short_name"
        ],
        "_filled": [
            "name",
            "account_id",
            "category_id",
            "startup_date",
            "location_status_id",
            "region_id",
            "is_archived",
            "is_onboarding",
            "already_open"
        ],
        "_unique": [
            "name"
        ]
    },
    "LocationZone": {
        "id": "number",
        "_displayName": "'Location Zone'",
        "_slug": "'location_zone'",
        "account": "Account",
        "addresses": "Address",
        "autogen_attempts": "PlaylistGenerationAttempt[]",
        "banned_artists": "BannedArtist[]",
        "banned_tracks": "BannedTrack[]",
        "beta_pg": "boolean",
        "buckets": "Bucket[]",
        "categories": "Category",
        "contacts": "Contact",
        "content_cycle": "number",
        "content_style": "ContentStyle",
        "content_style_id": "number",
        "content_styling_frequency": "number",
        "cost_level": "number",
        "create_notification_sent": "boolean",
        "created_at": "Date",
        "created_by_user": "User",
        "created_by_user_id": "number",
        "custom_publishes": "LocationZoneContentPublish[]",
        "default_template": "Template",
        "default_template_id": "number",
        "deleted_at": "Date",
        "description": "string",
        "does_use_ach_push": "boolean",
        "does_use_ach_recurring": "boolean",
        "does_use_check": "boolean",
        "does_use_credit_card": "boolean",
        "final_onboarding_email_sent": "boolean",
        "five_day_followup": "boolean",
        "followup_frequency_days": "number",
        "has_master_service_agreement": "boolean",
        "hide_internal_votes": "boolean",
        "holiday_default_template": "Template",
        "holiday_default_template_id": "number",
        "ignore_master_location_zone_votes": "boolean",
        "initial_onboarding_email_user": "User",
        "initial_onboarding_email_user_id": "number",
        "instore_player_contacts": "Contact[]",
        "invoiced": "boolean",
        "is_archived": "boolean",
        "is_internal": "boolean",
        "is_music_zone": "boolean",
        "is_onboarding": "boolean",
        "is_past_due": "boolean",
        "is_past_due_date": "Date",
        "is_past_due_user": "User",
        "is_past_due_user_id": "number",
        "is_tpg_location_zone": "boolean",
        "last_content_checkup_reminder_date": "Date",
        "last_followup_date": "Date",
        "last_followup_user": "User",
        "last_followup_user_id": "number",
        "last_onboarding_email_date": "Date",
        "latest_autogen_attempt": "PlaylistGenerationAttempt",
        "location": "Location",
        "location_id": "number",
        "location_zone_custom_playlist_sources": "string",
        "location_zone_custom_playlists": "LocationZoneCustomPlaylist[]",
        "location_zone_fee": "LocationZoneFee",
        "location_zone_playback_timeframes": "LocationZonePlaybackTimeframe[]",
        "location_zone_players": "LocationZonePlayer[]",
        "location_zone_status": "LocationZoneStatus",
        "location_zone_status_id": "number",
        "location_zone_tier": "LocationZoneTier",
        "location_zone_tier_id": "number",
        "loop_lists": "boolean",
        "master_location_zone": "LocationZone",
        "master_location_zone_id": "number",
        "monthly_payment_type": "PaymentType",
        "monthly_payment_type_id": "number",
        "music_zone_folders": "MusicZoneFolder",
        "name": "string",
        "onboarding_manager_user": "User",
        "onboarding_manager_user_id": "number",
        "onboarding_user": "User",
        "onboarding_user_id": "number",
        "payments_tally": "number",
        "phone_numbers": "PhoneNumber",
        "physical_address": "string",
        "playlist_cycle": "number",
        "playlist_generation_attempts": "PlaylistGenerationAttempt[]",
        "playlist_manager_group": "PlaylistManagerGroup",
        "playlist_manager_group_id": "number",
        "recurring_followup_user": "User",
        "recurring_followup_user_id": "number",
        "rotate_requirement": "number",
        "scheduling_mode": "SchedulingMode",
        "scheduling_mode_id": "number",
        "should_include_master_location_zone_votes": "boolean",
        "startup_date": "Date",
        "startup_payment_type": "PaymentType",
        "startup_payment_type_id": "number",
        "subscribers": "LocationZone[]",
        "subscribers_count": "number",
        "tags": "Tag",
        "time_zone": "TimeZone",
        "time_zone_id": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "website_url": "string",
        "_nullable": [
            "content_cycle",
            "default_template_id",
            "location_zone_status_id",
            "master_location_zone_id",
            "created_at",
            "user_id",
            "content_style_id",
            "content_styling_frequency",
            "last_content_checkup_reminder_date",
            "is_past_due_user_id",
            "is_past_due_date",
            "create_notification_sent",
            "playlist_manager_group_id",
            "has_master_service_agreement",
            "website_url",
            "location_zone_custom_playlist_sources",
            "onboarding_user_id",
            "created_by_user_id",
            "initial_onboarding_email_user_id",
            "last_onboarding_email_date",
            "onboarding_manager_user_id",
            "monthly_payment_type_id",
            "startup_payment_type_id",
            "five_day_followup",
            "recurring_followup_user_id",
            "last_followup_date",
            "last_followup_user_id",
            "followup_frequency_days",
            "cost_level",
            "beta_pg",
            "holiday_default_template_id",
            "startup_date",
            "description",
            "scheduling_mode_id",
            "deleted_at"
        ],
        "_columnNameMappings": {
            "location_zone_custom_playlists": "custom_lists"
        },
        "_filterFieldMappings": {
            "location": "location.display_string",
            "default_template": "default_template.display_string",
            "location_zone_status": "location_zone_status.display_string",
            "created_by_user": "created_by_user.display_string",
            "holiday_default_template": "holiday_default_template.display_string",
            "initial_onboarding_email_user": "initial_onboarding_email_user.display_string",
            "is_past_due_user": "is_past_due_user.display_string",
            "latest_autogen_attempt": "latest_autogen_attempt.display_string",
            "location_zone_fee": "location_zone_fee.display_string",
            "location_zone_tier": "location_zone_tier.display_string",
            "monthly_payment_type": "monthly_payment_type.display_string",
            "startup_payment_type": "startup_payment_type.display_string",
            "onboarding_manager_user": "onboarding_manager_user.display_string",
            "recurring_followup_user": "recurring_followup_user.display_string",
            "master_location_zone": "master_location_zone.display_string",
            "user": "user.display_string",
            "content_style": "content_style.display_string",
            "playlist_manager_group": "playlist_manager_group.display_string",
            "location_zone_custom_playlist_source": "location_zone_custom_playlist_source.display_string",
            "onboarding_user": "onboarding_user.display_string",
            "last_followup_user": "last_followup_user.display_string",
            "account": "account.display_string",
            "time_zone": "time_zone.display_string",
            "scheduling_mode": "scheduling_mode.display_string",
            "instore_player_contacts": "instore_player_contacts.display_string",
            "buckets": "buckets.display_string",
            "location_zone_players": "location_zone_players.display_string",
            "location_zone_playback_timeframes": "location_zone_playback_timeframes.display_string",
            "playlist_generation_attempts": "playlist_generation_attempts.display_string",
            "autogen_attempts": "autogen_attempts.display_string",
            "tags": "tags.display_string",
            "addresses": "addresses.display_string",
            "phone_numbers": "phone_numbers.display_string",
            "contacts": "contacts.display_string",
            "categories": "categories.display_string",
            "location_zone_custom_playlists": "location_zone_custom_playlists.display_string"
        },
        "_frontendFields": {
            "physical_address": {
                "type": "string"
            },
            "subscribers_count": {
                "type": "integer"
            }
        },
        "_childrenMappings": {
            "tags": "tag",
            "addresses": "address",
            "phone_numbers": "phone_number",
            "contacts": "contact",
            "categories": "category",
            "location_zone_custom_playlists": "location_zone_custom_playlist"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "physical_address",
            "geo_location",
            "location_id",
            "location",
            "rotate_requirement",
            "content_cycle",
            "default_template_id",
            "default_template",
            "loop_lists",
            "location_zone_status_id",
            "location_zone_status",
            "created_by_user",
            "holiday_default_template",
            "initial_onboarding_email_user",
            "is_past_due_user",
            "latest_autogen_attempt",
            "location_zone_fee",
            "location_zone_tier",
            "monthly_payment_type",
            "startup_payment_type",
            "onboarding_manager_user",
            "recurring_followup_user",
            "playlist_cycle",
            "master_location_zone_id",
            "master_location_zone",
            "invoiced",
            "user_id",
            "user",
            "content_style_id",
            "content_style",
            "content_styling_frequency",
            "last_content_checkup_reminder_date",
            "ignore_master_location_zone_votes",
            "is_tpg_location_zone",
            "should_include_master_location_zone_votes",
            "is_past_due",
            "is_past_due_user_id",
            "is_past_due_date",
            "create_notification_sent",
            "playlist_manager_group_id",
            "playlist_manager_group",
            "does_use_credit_card",
            "has_master_service_agreement",
            "does_use_ach_recurring",
            "does_use_ach_push",
            "does_use_check",
            "website_url",
            "location_zone_custom_playlist_sources",
            "location_zone_custom_playlist_source_id",
            "location_zone_custom_playlist_source",
            "is_onboarding",
            "onboarding_user_id",
            "onboarding_user",
            "created_by_user_id",
            "hide_internal_votes",
            "initial_onboarding_email_user_id",
            "last_onboarding_email_date",
            "final_onboarding_email_sent",
            "onboarding_manager_user_id",
            "monthly_payment_type_id",
            "startup_payment_type_id",
            "five_day_followup",
            "recurring_followup_user_id",
            "last_followup_date",
            "last_followup_user_id",
            "last_followup_user",
            "followup_frequency_days",
            "cost_level",
            "beta_pg",
            "payments_tally",
            "is_archived",
            "holiday_default_template_id",
            "location_zone_tier_id",
            "account",
            "created_at",
            "updated_at",
            "time_zone_id",
            "time_zone",
            "is_music_zone",
            "startup_date",
            "is_internal",
            "subscribers_count",
            "description",
            "scheduling_mode_id",
            "scheduling_mode",
            "instore_player_contacts",
            "buckets",
            "location_zone_players",
            "location_zone_playback_timeframes",
            "playlist_generation_attempts",
            "autogen_attempts",
            "tags",
            "addresses",
            "phone_numbers",
            "contacts",
            "categories",
            "location_zone_custom_playlists"
        ],
        "_quickSearch": {
            "defaults": [
                "location.display_string",
                "name",
                "account.display_string"
            ],
            "offered": [
                {
                    "key": "account.display_string",
                    "label": "Account",
                    "kind": "text"
                },
                {
                    "key": "addresses.display_string",
                    "label": "Addresses",
                    "kind": "text"
                },
                {
                    "key": "autogen_attempts.display_string",
                    "label": "Autogen attempts",
                    "kind": "text"
                },
                {
                    "key": "buckets.display_string",
                    "label": "Buckets",
                    "kind": "text"
                },
                {
                    "key": "categories.display_string",
                    "label": "Categories",
                    "kind": "text"
                },
                {
                    "key": "contacts.display_string",
                    "label": "Contacts",
                    "kind": "text"
                },
                {
                    "key": "content_cycle",
                    "label": "Content cycle",
                    "kind": "number"
                },
                {
                    "key": "content_style.display_string",
                    "label": "Content style",
                    "kind": "text"
                },
                {
                    "key": "content_style_id",
                    "label": "Content style id",
                    "kind": "number"
                },
                {
                    "key": "content_styling_frequency",
                    "label": "Content styling frequency",
                    "kind": "number"
                },
                {
                    "key": "cost_level",
                    "label": "Cost level",
                    "kind": "number"
                },
                {
                    "key": "created_by_user.display_string",
                    "label": "Created by user",
                    "kind": "text"
                },
                {
                    "key": "created_by_user_id",
                    "label": "Created by user id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_custom_playlists.display_string",
                    "label": "Custom lists",
                    "kind": "text"
                },
                {
                    "key": "default_template.display_string",
                    "label": "Default template",
                    "kind": "text"
                },
                {
                    "key": "default_template_id",
                    "label": "Default template id",
                    "kind": "number"
                },
                {
                    "key": "description",
                    "label": "Description",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "followup_frequency_days",
                    "label": "Followup frequency days",
                    "kind": "number"
                },
                {
                    "key": "holiday_default_template.display_string",
                    "label": "Holiday default template",
                    "kind": "text"
                },
                {
                    "key": "holiday_default_template_id",
                    "label": "Holiday default template id",
                    "kind": "number"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "initial_onboarding_email_user.display_string",
                    "label": "Initial onboarding email user",
                    "kind": "text"
                },
                {
                    "key": "initial_onboarding_email_user_id",
                    "label": "Initial onboarding email user id",
                    "kind": "number"
                },
                {
                    "key": "instore_player_contacts.display_string",
                    "label": "Instore player contacts",
                    "kind": "text"
                },
                {
                    "key": "is_past_due_user.display_string",
                    "label": "Is past due user",
                    "kind": "text"
                },
                {
                    "key": "is_past_due_user_id",
                    "label": "Is past due user id",
                    "kind": "number"
                },
                {
                    "key": "last_followup_user.display_string",
                    "label": "Last followup user",
                    "kind": "text"
                },
                {
                    "key": "last_followup_user_id",
                    "label": "Last followup user id",
                    "kind": "number"
                },
                {
                    "key": "latest_autogen_attempt.display_string",
                    "label": "Latest autogen attempt",
                    "kind": "text"
                },
                {
                    "key": "location.display_string",
                    "label": "Location",
                    "kind": "text"
                },
                {
                    "key": "location_id",
                    "label": "Location id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_custom_playlist_source.display_string",
                    "label": "Location zone custom playlist source",
                    "kind": "text"
                },
                {
                    "key": "location_zone_custom_playlist_source_id",
                    "label": "Location zone custom playlist source id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_custom_playlist_sources",
                    "label": "Location zone custom playlist sources",
                    "kind": "text"
                },
                {
                    "key": "location_zone_fee.display_string",
                    "label": "Location zone fee",
                    "kind": "text"
                },
                {
                    "key": "location_zone_playback_timeframes.display_string",
                    "label": "Location zone playback timeframes",
                    "kind": "text"
                },
                {
                    "key": "location_zone_players.display_string",
                    "label": "Location zone players",
                    "kind": "text"
                },
                {
                    "key": "location_zone_status.display_string",
                    "label": "Location zone status",
                    "kind": "text"
                },
                {
                    "key": "location_zone_status_id",
                    "label": "Location zone status id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_tier.display_string",
                    "label": "Location zone tier",
                    "kind": "text"
                },
                {
                    "key": "location_zone_tier_id",
                    "label": "Location zone tier id",
                    "kind": "number"
                },
                {
                    "key": "master_location_zone.display_string",
                    "label": "Master location zone",
                    "kind": "text"
                },
                {
                    "key": "master_location_zone_id",
                    "label": "Master location zone id",
                    "kind": "number"
                },
                {
                    "key": "monthly_payment_type.display_string",
                    "label": "Monthly payment type",
                    "kind": "text"
                },
                {
                    "key": "monthly_payment_type_id",
                    "label": "Monthly payment type id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "onboarding_manager_user.display_string",
                    "label": "Onboarding manager user",
                    "kind": "text"
                },
                {
                    "key": "onboarding_manager_user_id",
                    "label": "Onboarding manager user id",
                    "kind": "number"
                },
                {
                    "key": "onboarding_user.display_string",
                    "label": "Onboarding user",
                    "kind": "text"
                },
                {
                    "key": "onboarding_user_id",
                    "label": "Onboarding user id",
                    "kind": "number"
                },
                {
                    "key": "payments_tally",
                    "label": "Payments tally",
                    "kind": "number"
                },
                {
                    "key": "phone_numbers.display_string",
                    "label": "Phone numbers",
                    "kind": "text"
                },
                {
                    "key": "physical_address",
                    "label": "Physical address",
                    "kind": "text"
                },
                {
                    "key": "playlist_cycle",
                    "label": "Playlist cycle",
                    "kind": "number"
                },
                {
                    "key": "playlist_generation_attempts.display_string",
                    "label": "Playlist generation attempts",
                    "kind": "text"
                },
                {
                    "key": "playlist_manager_group.display_string",
                    "label": "Playlist manager group",
                    "kind": "text"
                },
                {
                    "key": "playlist_manager_group_id",
                    "label": "Playlist manager group id",
                    "kind": "number"
                },
                {
                    "key": "recurring_followup_user.display_string",
                    "label": "Recurring followup user",
                    "kind": "text"
                },
                {
                    "key": "recurring_followup_user_id",
                    "label": "Recurring followup user id",
                    "kind": "number"
                },
                {
                    "key": "rotate_requirement",
                    "label": "Rotate requirement",
                    "kind": "number"
                },
                {
                    "key": "scheduling_mode.display_string",
                    "label": "Scheduling mode",
                    "kind": "text"
                },
                {
                    "key": "scheduling_mode_id",
                    "label": "Scheduling mode id",
                    "kind": "number"
                },
                {
                    "key": "startup_payment_type.display_string",
                    "label": "Startup payment type",
                    "kind": "text"
                },
                {
                    "key": "startup_payment_type_id",
                    "label": "Startup payment type id",
                    "kind": "number"
                },
                {
                    "key": "subscribers_count",
                    "label": "Subscribers count",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "time_zone.display_string",
                    "label": "Time zone",
                    "kind": "text"
                },
                {
                    "key": "time_zone_id",
                    "label": "Time zone id",
                    "kind": "number"
                },
                {
                    "key": "user.display_string",
                    "label": "User",
                    "kind": "text"
                },
                {
                    "key": "user_id",
                    "label": "User id",
                    "kind": "number"
                },
                {
                    "key": "website_url",
                    "label": "Website url",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "location_id",
            "account_id",
            "rotate_requirement",
            "content_cycle",
            "default_template_id",
            "loop_lists",
            "location_zone_status_id",
            "playlist_cycle",
            "invoiced",
            "user_id",
            "content_style_id",
            "content_styling_frequency",
            "ignore_master_location_zone_votes",
            "is_tpg_location_zone",
            "should_include_master_location_zone_votes",
            "is_past_due",
            "is_past_due_user_id",
            "create_notification_sent",
            "playlist_manager_group_id",
            "does_use_credit_card",
            "has_master_service_agreement",
            "does_use_ach_recurring",
            "does_use_ach_push",
            "does_use_check",
            "website_url",
            "master_service_agreement_id",
            "location_zone_custom_playlist_sources",
            "is_onboarding",
            "onboarding_user_id",
            "created_by_user_id",
            "hide_internal_votes",
            "initial_onboarding_email_user_id",
            "final_onboarding_email_sent",
            "onboarding_manager_user_id",
            "monthly_payment_type_id",
            "startup_payment_type_id",
            "five_day_followup",
            "recurring_followup_user_id",
            "followup_frequency_days",
            "cost_level",
            "beta_pg",
            "payments_tally",
            "is_archived",
            "holiday_default_template_id",
            "location_zone_tier_id",
            "time_zone_id",
            "is_music_zone",
            "is_internal",
            "scheduling_mode_id"
        ],
        "_unique": []
    },
    "LocationZoneCustomPlaylist": {
        "id": "number",
        "OLD_use_daily_playlists": "boolean",
        "_displayName": "'Custom Playlist'",
        "_slug": "'location_zone_custom_playlist'",
        "account": "Account",
        "artist_repeat_limit_hours": "number",
        "code": "string",
        "cover_track": "LiveTrack",
        "cover_track_id": "number",
        "created_at": "Date",
        "created_from_script": "boolean",
        "deleted_at": "Date",
        "details": "string",
        "download_priority": "number",
        "effective_location_zone": "LocationZone",
        "effective_location_zone_custom_playlist_schedules": "LocationZoneCustomPlaylistSchedule[]",
        "expiration_date": "Date",
        "expiration_time_zone": "TimeZone",
        "expiration_time_zone_id": "number",
        "is_interactive": "boolean",
        "is_published": "boolean",
        "is_sample_list": "boolean",
        "is_visible_to_client": "boolean",
        "location": "Location",
        "location_zone": "LocationZone",
        "location_zone_custom_playlist_schedules": "LocationZoneCustomPlaylistSchedule[]",
        "location_zone_custom_playlist_status": "LocationZoneCustomPlaylistStatus",
        "location_zone_custom_playlist_status_id": "number",
        "location_zone_custom_playlist_tracks": "LocationZoneCustomPlaylistTrack[]",
        "location_zone_id": "number",
        "location_zone_is_archived": "boolean",
        "name": "string",
        "should_download_to_players": "boolean",
        "show_track_info": "boolean",
        "shuffle": "boolean",
        "source_bucket": "Bucket",
        "source_bucket_id": "number",
        "source_bucket_is_vault": "boolean",
        "special_event": "boolean",
        "status_expiration": "Date",
        "status_expiration_timezone": "TimeZone",
        "status_expiration_timezone_id": "number",
        "tags": "Tag",
        "tracks": "LiveTrack",
        "updated_at": "Date",
        "user": "User",
        "user_can_shuffle": "boolean",
        "user_id": "number",
        "z_delimited_track_ids": "string",
        "_nullable": [
            "location_zone_id",
            "user_id",
            "z_delimited_track_ids",
            "source_bucket_id",
            "created_at",
            "updated_at",
            "shuffle",
            "OLD_use_daily_playlists",
            "expiration_date",
            "expiration_time_zone_id",
            "details",
            "code",
            "should_download_to_players",
            "cover_track_id",
            "is_sample_list",
            "artist_repeat_limit_hours",
            "status_expiration",
            "status_expiration_timezone_id",
            "download_priority",
            "deleted_at"
        ],
        "_columnNameMappings": {
            "location_zone_custom_playlist_schedules": "schedules"
        },
        "_filterFieldMappings": {
            "location_zone": "location_zone.display_string",
            "location": "location.display_string",
            "user": "user.display_string",
            "source_bucket": "source_bucket.display_string",
            "source_bucket_base_bucket": "source_bucket_base_bucket.display_string",
            "location_zone_custom_playlist_status": "location_zone_custom_playlist_status.display_string",
            "account": "account.display_string",
            "effective_location_zone": "effective_location_zone.display_string",
            "expiration_time_zone": "expiration_time_zone.display_string",
            "cover_track": "cover_track.display_string",
            "status_expiration_timezone": "status_expiration_timezone.display_string",
            "location_zone_custom_playlist_schedules": "location_zone_custom_playlist_schedules.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "location_zone_id",
            "location_zone",
            "location",
            "user_id",
            "user",
            "name",
            "display_string",
            "source_bucket_id",
            "source_bucket",
            "source_bucket_is_vault",
            "source_bucket_base_bucket",
            "location_zone_is_archived",
            "created_at",
            "updated_at",
            "details",
            "code",
            "location_zone_custom_playlist_status_id",
            "location_zone_custom_playlist_status",
            "account",
            "effective_location_zone",
            "expiration_time_zone",
            "cover_track_id",
            "cover_track",
            "shuffle",
            "user_can_shuffle",
            "special_event",
            "artist_repeat_limit_hours",
            "status_expiration",
            "status_expiration_timezone_id",
            "status_expiration_timezone",
            "download_priority",
            "location_zone_custom_playlist_schedules",
            "tags",
            "track_count",
            "track_count_counted_at"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "location_zone.display_string"
            ],
            "offered": [
                {
                    "key": "account.display_string",
                    "label": "Account",
                    "kind": "text"
                },
                {
                    "key": "artist_repeat_limit_hours",
                    "label": "Artist repeat limit hours",
                    "kind": "number"
                },
                {
                    "key": "code",
                    "label": "Code",
                    "kind": "text"
                },
                {
                    "key": "cover_track.display_string",
                    "label": "Cover track",
                    "kind": "text"
                },
                {
                    "key": "cover_track_id",
                    "label": "Cover track id",
                    "kind": "number"
                },
                {
                    "key": "details",
                    "label": "Details",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "download_priority",
                    "label": "Download priority",
                    "kind": "number"
                },
                {
                    "key": "effective_location_zone.display_string",
                    "label": "Effective location zone",
                    "kind": "text"
                },
                {
                    "key": "expiration_time_zone.display_string",
                    "label": "Expiration time zone",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "location.display_string",
                    "label": "Location",
                    "kind": "text"
                },
                {
                    "key": "location_zone_custom_playlist_status.display_string",
                    "label": "Location zone custom playlist status",
                    "kind": "text"
                },
                {
                    "key": "location_zone_custom_playlist_status_id",
                    "label": "Location zone custom playlist status id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_id",
                    "label": "Location zone id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "location_zone_custom_playlist_schedules.display_string",
                    "label": "Schedules",
                    "kind": "text"
                },
                {
                    "key": "source_bucket.display_string",
                    "label": "Source bucket",
                    "kind": "text"
                },
                {
                    "key": "source_bucket_id",
                    "label": "Source bucket id",
                    "kind": "number"
                },
                {
                    "key": "status_expiration_timezone.display_string",
                    "label": "Status expiration timezone",
                    "kind": "text"
                },
                {
                    "key": "status_expiration_timezone_id",
                    "label": "Status expiration timezone id",
                    "kind": "number"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "track_count",
                    "label": "Track count",
                    "kind": "number"
                },
                {
                    "key": "user.display_string",
                    "label": "User",
                    "kind": "text"
                },
                {
                    "key": "user_id",
                    "label": "User id",
                    "kind": "number"
                },
                {
                    "key": "location_zone.display_string",
                    "label": "Zone",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "created_at"
        ],
        "_filled": [
            "code"
        ],
        "_unique": []
    },
    "LocationZoneCustomPlaylistSchedule": {
        "id": "number",
        "_displayName": "'Custom Playlist Schedule'",
        "_slug": "'custom_playlist_schedule'",
        "complete_track": "boolean",
        "created_at": "Date",
        "custom_playlist_insert_type": "CustomPlaylistInsertType",
        "custom_playlist_insert_type_id": "number",
        "custom_playlist_schedule_type": "CustomPlaylistScheduleType",
        "custom_playlist_schedule_type_id": "number",
        "date": "string",
        "deleted_at": "Date",
        "delimited_day_ids": "string",
        "effective_end_datetime": "Date",
        "effective_start_datetime": "Date",
        "end_date": "string",
        "end_time": "string",
        "ignore_dl_window": "boolean",
        "insert_frequency_ramp_days": "number",
        "insert_frequency_tracks_start": "number",
        "insert_frequency_tracks_target": "number",
        "is_recurring": "boolean",
        "location_zone": "LocationZone",
        "location_zone_custom_playlist": "LocationZoneCustomPlaylist",
        "location_zone_custom_playlist_id": "number",
        "location_zone_id": "number",
        "loop": "boolean",
        "messaging_end_time": "string",
        "messaging_frequency_minutes": "number",
        "messaging_start_time": "string",
        "natural_language_date_expression": "string",
        "natural_language_end_date_expression": "string",
        "priority": "number",
        "recurring_end_date": "string",
        "recurring_start_date": "string",
        "recurring_weekly_interval": "number",
        "resume_from_file_offset": "boolean",
        "revert_to_daily": "boolean",
        "should_shuffle": "boolean",
        "silence": "boolean",
        "station_change_location_zone_player": "LocationZonePlayer",
        "station_change_location_zone_player_id": "number",
        "time": "string",
        "updated_at": "Date",
        "_nullable": [
            "location_zone_id",
            "location_zone_custom_playlist_id",
            "effective_start_datetime",
            "effective_end_datetime",
            "natural_language_date_expression",
            "natural_language_end_date_expression",
            "date",
            "time",
            "end_date",
            "end_time",
            "custom_playlist_schedule_type_id",
            "station_change_location_zone_player_id",
            "loop",
            "delimited_day_ids",
            "complete_track",
            "ignore_dl_window",
            "recurring_start_date",
            "recurring_end_date",
            "revert_to_daily",
            "custom_playlist_insert_type_id",
            "messaging_start_time",
            "messaging_end_time",
            "messaging_frequency_minutes",
            "silence",
            "resume_from_file_offset",
            "priority",
            "created_at",
            "updated_at",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "location_zone": "location_zone.display_string",
            "location_zone_custom_playlist": "location_zone_custom_playlist.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": [],
        "_searchable": [
            "id",
            "location_zone_id",
            "location_zone",
            "location_zone_custom_playlist_id",
            "location_zone_custom_playlist",
            "date",
            "natural_language_date_expression",
            "time",
            "end_date",
            "natural_language_end_date_expression",
            "end_time",
            "custom_playlist_schedule_type_id",
            "station_change_location_zone_player_id",
            "loop",
            "delimited_day_ids",
            "should_shuffle",
            "complete_track",
            "ignore_dl_window",
            "is_recurring",
            "recurring_start_date",
            "recurring_end_date",
            "effective_start_datetime",
            "effective_end_datetime",
            "recurring_weekly_interval",
            "revert_to_daily",
            "custom_playlist_insert_type_id",
            "insert_frequency_tracks_start",
            "insert_frequency_tracks_target",
            "insert_frequency_ramp_days",
            "messaging_start_time",
            "messaging_end_time",
            "messaging_frequency_minutes",
            "silence",
            "resume_from_file_offset",
            "priority",
            "created_at",
            "updated_at"
        ],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "location_zone_id",
            "location_zone_custom_playlist_id",
            "custom_playlist_schedule_type_id",
            "revert_to_daily",
            "custom_playlist_insert_type_id"
        ],
        "_unique": []
    },
    "LocationZonePlayer": {
        "id": "number",
        "_displayName": "'Location Zone Player'",
        "_slug": "'location_zone_player'",
        "account": "Account",
        "audio_device": "string",
        "brand_id": "number",
        "can_set_volume": "boolean",
        "can_skip": "boolean",
        "can_vote": "boolean",
        "client_did_set_muted": "boolean",
        "client_did_set_volume": "boolean",
        "complete_track": "boolean",
        "created_at": "Date",
        "crossfade_duration": "number",
        "crossfade_type": "CrossfadeType",
        "crossfade_type_id": "number",
        "deleted_at": "Date",
        "download_end_hour": "number",
        "download_start_hour": "number",
        "last_loaded_archive": "string",
        "last_loaded_date": "Date",
        "location": "Location",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "location_zone_player_data": "LocationZonePlayerData[]",
        "location_zone_player_stream_mode": "LocationZonePlayerStreamMode",
        "location_zone_player_stream_mode_id": "number",
        "mono": "boolean",
        "player": "Player",
        "player_alternate_dns_1": "string",
        "player_alternate_dns_2": "string",
        "player_check_interval": "number",
        "player_curlcli": "boolean",
        "player_data_channels": "string",
        "player_data_checkin_marker": "Date",
        "player_data_current_playlist_name": "string",
        "player_data_current_track_code": "string",
        "player_data_date": "Date",
        "player_data_disk_size_gb": "number",
        "player_data_disk_usage": "string",
        "player_data_disk_usage_percentage": "number",
        "player_data_dns_1": "string",
        "player_data_dns_2": "string",
        "player_data_drive": "string",
        "player_data_gateway": "string",
        "player_data_internal_ip": "string",
        "player_data_ip_mode": "string",
        "player_data_is_internal": "boolean",
        "player_data_is_online": "boolean",
        "player_data_kernel": "string",
        "player_data_lan": "string",
        "player_data_last_loaded_archive": "string",
        "player_data_last_loaded_date": "Date",
        "player_data_mac_address": "string",
        "player_data_model_type": "string",
        "player_data_playing": "number",
        "player_data_playlist_track_number": "number",
        "player_data_playlist_track_total": "number",
        "player_data_proxy": "string",
        "player_data_referenced_content_missing": "number",
        "player_data_referenced_content_total": "number",
        "player_data_remote_ip": "string",
        "player_data_subnet": "string",
        "player_data_time_zone": "string",
        "player_data_updated_at": "Date",
        "player_data_version": "string",
        "player_data_volume": "number",
        "player_id": "number",
        "player_nrm": "string",
        "player_protocol": "string",
        "player_server": "PlayerServer",
        "player_stream_logging": "boolean",
        "player_throttle": "number",
        "player_time_zone": "string",
        "player_type": "PlayerType",
        "player_use_public_dns_servers": "boolean",
        "set_volume_contact": "Contact",
        "set_volume_contact_id": "number",
        "tags": "Tag",
        "updated_at": "Date",
        "volume": "number",
        "_nullable": [
            "location_zone_id",
            "player_id",
            "brand_id",
            "created_at",
            "updated_at",
            "location_zone_player_stream_mode_id",
            "mono",
            "download_start_hour",
            "download_end_hour",
            "client_did_set_muted",
            "last_loaded_date",
            "last_loaded_archive",
            "crossfade_duration",
            "crossfade_type_id",
            "complete_track",
            "can_set_volume",
            "deleted_at"
        ],
        "_columnNameMappings": {
            "player_check_interval": "check_interval",
            "player_throttle": "throttle",
            "player_time_zone": "time_zone",
            "player_protocol": "protocol",
            "player_nrm": "nrm",
            "player_stream_logging": "stream_logging",
            "player_use_public_dns_servers": "use_public_dns_servers",
            "player_alternate_dns_1": "alternate_dns_1",
            "player_alternate_dns_2": "alternate_dns_2",
            "player_curlcli": "curlcli",
            "player_data_is_online": "online",
            "player_data_playing": "playing",
            "player_data_current_track_code": "current_track",
            "player_data_current_playlist_name": "current_playlist",
            "player_data_playlist_track_number": "playlist_track_number",
            "player_data_playlist_track_total": "playlist_track_total",
            "player_data_referenced_content_missing": "referenced_content_missing",
            "player_data_referenced_content_total": "referenced_content_total",
            "player_data_disk_usage": "disk_usage",
            "player_data_disk_usage_percentage": "disk_usage_percentage",
            "player_data_disk_size_gb": "disk_size_gb",
            "player_data_date": "checkin_date",
            "player_data_updated_at": "last_checkin",
            "player_data_version": "version",
            "player_data_volume": "current_volume",
            "player_data_time_zone": "reported_time_zone",
            "player_data_remote_ip": "remote_ip",
            "player_data_mac_address": "mac_address",
            "player_data_internal_ip": "internal_ip",
            "player_data_lan": "lan",
            "player_data_subnet": "subnet",
            "player_data_gateway": "gateway",
            "player_data_proxy": "proxy",
            "player_data_ip_mode": "ip_mode",
            "player_data_dns_1": "dns_1",
            "player_data_dns_2": "dns_2",
            "player_data_is_internal": "is_internal",
            "player_data_channels": "channels",
            "player_data_drive": "drive",
            "player_data_kernel": "kernel",
            "player_data_model_type": "model_type",
            "player_data_checkin_marker": "checkin_marker",
            "player_data_last_loaded_date": "reported_last_loaded_date",
            "player_data_last_loaded_archive": "reported_last_loaded_archive",
            "brand_id": "brand"
        },
        "_filterFieldMappings": {
            "location_zone": "location_zone.display_string",
            "location_zone_player_stream_mode": "location_zone_player_stream_mode.display_string",
            "set_volume_contact": "set_volume_contact.display_string",
            "crossfade_type": "crossfade_type.display_string",
            "tags": "tags.display_string",
            "location": "location.display_string",
            "account": "account.display_string",
            "player_type": "player_type.display_string",
            "player_server": "player_server.display_string"
        },
        "_frontendFields": {
            "player_check_interval": {
                "type": "number"
            },
            "player_throttle": {
                "type": "number"
            },
            "player_time_zone": {
                "type": "string"
            },
            "player_protocol": {
                "type": "string"
            },
            "player_nrm": {
                "type": "string"
            },
            "player_stream_logging": {
                "type": "boolean"
            },
            "player_use_public_dns_servers": {
                "type": "boolean"
            },
            "player_alternate_dns_1": {
                "type": "string"
            },
            "player_alternate_dns_2": {
                "type": "string"
            },
            "player_curlcli": {
                "type": "boolean"
            },
            "player_data_is_online": {
                "type": "boolean"
            },
            "player_data_playing": {
                "type": "number"
            },
            "player_data_current_track_code": {
                "type": "string"
            },
            "player_data_current_playlist_name": {
                "type": "string"
            },
            "player_data_playlist_track_number": {
                "type": "number"
            },
            "player_data_playlist_track_total": {
                "type": "number"
            },
            "player_data_referenced_content_missing": {
                "type": "number"
            },
            "player_data_referenced_content_total": {
                "type": "number"
            },
            "player_data_disk_usage": {
                "type": "string"
            },
            "player_data_disk_usage_percentage": {
                "type": "number"
            },
            "player_data_disk_size_gb": {
                "type": "number"
            },
            "player_data_date": {
                "type": "Date"
            },
            "player_data_updated_at": {
                "type": "Date"
            },
            "player_data_version": {
                "type": "string"
            },
            "player_data_volume": {
                "type": "number"
            },
            "player_data_time_zone": {
                "type": "string"
            },
            "player_data_remote_ip": {
                "type": "string"
            },
            "player_data_mac_address": {
                "type": "string"
            },
            "player_data_internal_ip": {
                "type": "string"
            },
            "player_data_lan": {
                "type": "string"
            },
            "player_data_subnet": {
                "type": "string"
            },
            "player_data_gateway": {
                "type": "string"
            },
            "player_data_proxy": {
                "type": "string"
            },
            "player_data_ip_mode": {
                "type": "string"
            },
            "player_data_dns_1": {
                "type": "string"
            },
            "player_data_dns_2": {
                "type": "string"
            },
            "player_data_is_internal": {
                "type": "boolean"
            },
            "player_data_channels": {
                "type": "string"
            },
            "player_data_drive": {
                "type": "string"
            },
            "player_data_kernel": {
                "type": "string"
            },
            "player_data_model_type": {
                "type": "string"
            },
            "player_data_checkin_marker": {
                "type": "Date"
            },
            "player_data_last_loaded_date": {
                "type": "Date"
            },
            "player_data_last_loaded_archive": {
                "type": "string"
            }
        },
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "location_zone_id",
            "location_zone",
            "brand_id",
            "player_id",
            "volume",
            "created_at",
            "updated_at",
            "location_zone_player_stream_mode_id",
            "location_zone_player_stream_mode",
            "mono",
            "download_start_hour",
            "download_end_hour",
            "client_did_set_volume",
            "client_did_set_muted",
            "set_volume_contact_id",
            "set_volume_contact",
            "can_vote",
            "audio_device",
            "can_skip",
            "last_loaded_date",
            "last_loaded_archive",
            "crossfade_duration",
            "crossfade_type_id",
            "crossfade_type",
            "complete_track",
            "can_set_volume",
            "tags",
            "location",
            "account",
            "player_type",
            "player_server",
            "player_check_interval",
            "player_throttle",
            "player_time_zone",
            "player_protocol",
            "player_nrm",
            "player_stream_logging",
            "player_use_public_dns_servers",
            "player_alternate_dns_1",
            "player_alternate_dns_2",
            "player_curlcli",
            "player_data_is_online",
            "player_data_playing",
            "player_data_current_track_code",
            "player_data_current_playlist_name",
            "player_data_playlist_track_number",
            "player_data_playlist_track_total",
            "player_data_referenced_content_missing",
            "player_data_referenced_content_total",
            "player_data_disk_usage",
            "player_data_disk_usage_percentage",
            "player_data_disk_size_gb",
            "player_data_date",
            "player_data_updated_at",
            "player_data_version",
            "player_data_volume",
            "player_data_time_zone",
            "player_data_remote_ip",
            "player_data_mac_address",
            "player_data_internal_ip",
            "player_data_lan",
            "player_data_subnet",
            "player_data_gateway",
            "player_data_proxy",
            "player_data_ip_mode",
            "player_data_dns_1",
            "player_data_dns_2",
            "player_data_is_internal",
            "player_data_channels",
            "player_data_drive",
            "player_data_kernel",
            "player_data_model_type",
            "player_data_checkin_marker",
            "player_data_last_loaded_date",
            "player_data_last_loaded_archive"
        ],
        "_quickSearch": {
            "defaults": [
                "id",
                "location_zone.location.display_string",
                "location_zone.display_string",
                "player_data_mac_address",
                "player_data_remote_ip"
            ],
            "offered": [
                {
                    "key": "account.display_string",
                    "label": "Account",
                    "kind": "text"
                },
                {
                    "key": "player_alternate_dns_1",
                    "label": "Alternate dns 1",
                    "kind": "text"
                },
                {
                    "key": "player_alternate_dns_2",
                    "label": "Alternate dns 2",
                    "kind": "text"
                },
                {
                    "key": "audio_device",
                    "label": "Audio device",
                    "kind": "text"
                },
                {
                    "key": "brand_id",
                    "label": "Brand",
                    "kind": "number"
                },
                {
                    "key": "player_data_channels",
                    "label": "Channels",
                    "kind": "text"
                },
                {
                    "key": "player_check_interval",
                    "label": "Check interval",
                    "kind": "number"
                },
                {
                    "key": "crossfade_duration",
                    "label": "Crossfade duration",
                    "kind": "number"
                },
                {
                    "key": "crossfade_type.display_string",
                    "label": "Crossfade type",
                    "kind": "text"
                },
                {
                    "key": "crossfade_type_id",
                    "label": "Crossfade type id",
                    "kind": "number"
                },
                {
                    "key": "player_data_current_playlist_name",
                    "label": "Current playlist",
                    "kind": "text"
                },
                {
                    "key": "player_data_current_track_code",
                    "label": "Current track",
                    "kind": "text"
                },
                {
                    "key": "player_data_volume",
                    "label": "Current volume",
                    "kind": "number"
                },
                {
                    "key": "player_data_disk_size_gb",
                    "label": "Disk size gb",
                    "kind": "number"
                },
                {
                    "key": "player_data_disk_usage",
                    "label": "Disk usage",
                    "kind": "text"
                },
                {
                    "key": "player_data_disk_usage_percentage",
                    "label": "Disk usage percentage",
                    "kind": "number"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "player_data_dns_1",
                    "label": "Dns 1",
                    "kind": "text"
                },
                {
                    "key": "player_data_dns_2",
                    "label": "Dns 2",
                    "kind": "text"
                },
                {
                    "key": "download_end_hour",
                    "label": "Download end hour",
                    "kind": "number"
                },
                {
                    "key": "download_start_hour",
                    "label": "Download start hour",
                    "kind": "number"
                },
                {
                    "key": "player_data_drive",
                    "label": "Drive",
                    "kind": "text"
                },
                {
                    "key": "player_data_gateway",
                    "label": "Gateway",
                    "kind": "text"
                },
                {
                    "key": "player_data_internal_ip",
                    "label": "Internal ip",
                    "kind": "text"
                },
                {
                    "key": "player_data_ip_mode",
                    "label": "Ip mode",
                    "kind": "text"
                },
                {
                    "key": "player_data_kernel",
                    "label": "Kernel",
                    "kind": "text"
                },
                {
                    "key": "player_data_lan",
                    "label": "Lan",
                    "kind": "text"
                },
                {
                    "key": "last_loaded_archive",
                    "label": "Last loaded archive",
                    "kind": "text"
                },
                {
                    "key": "location.display_string",
                    "label": "Location",
                    "kind": "text"
                },
                {
                    "key": "location_zone.location.display_string",
                    "label": "Location",
                    "kind": "text"
                },
                {
                    "key": "location_zone_id",
                    "label": "Location zone id",
                    "kind": "number"
                },
                {
                    "key": "location_zone_player_stream_mode.display_string",
                    "label": "Location zone player stream mode",
                    "kind": "text"
                },
                {
                    "key": "location_zone_player_stream_mode_id",
                    "label": "Location zone player stream mode id",
                    "kind": "number"
                },
                {
                    "key": "player_data_mac_address",
                    "label": "MAC address",
                    "kind": "text"
                },
                {
                    "key": "player_data_model_type",
                    "label": "Model type",
                    "kind": "text"
                },
                {
                    "key": "player_nrm",
                    "label": "Nrm",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Player",
                    "kind": "number"
                },
                {
                    "key": "player_server.display_string",
                    "label": "Player server",
                    "kind": "text"
                },
                {
                    "key": "player_type.display_string",
                    "label": "Player type",
                    "kind": "text"
                },
                {
                    "key": "player_data_playing",
                    "label": "Playing",
                    "kind": "number"
                },
                {
                    "key": "player_data_playlist_track_number",
                    "label": "Playlist track number",
                    "kind": "number"
                },
                {
                    "key": "player_data_playlist_track_total",
                    "label": "Playlist track total",
                    "kind": "number"
                },
                {
                    "key": "player_protocol",
                    "label": "Protocol",
                    "kind": "text"
                },
                {
                    "key": "player_data_proxy",
                    "label": "Proxy",
                    "kind": "text"
                },
                {
                    "key": "player_data_remote_ip",
                    "label": "Public IP",
                    "kind": "text"
                },
                {
                    "key": "player_data_referenced_content_missing",
                    "label": "Referenced content missing",
                    "kind": "number"
                },
                {
                    "key": "player_data_referenced_content_total",
                    "label": "Referenced content total",
                    "kind": "number"
                },
                {
                    "key": "player_data_last_loaded_archive",
                    "label": "Reported last loaded archive",
                    "kind": "text"
                },
                {
                    "key": "player_data_time_zone",
                    "label": "Reported time zone",
                    "kind": "text"
                },
                {
                    "key": "set_volume_contact.display_string",
                    "label": "Set volume contact",
                    "kind": "text"
                },
                {
                    "key": "set_volume_contact_id",
                    "label": "Set volume contact id",
                    "kind": "number"
                },
                {
                    "key": "player_data_subnet",
                    "label": "Subnet",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                },
                {
                    "key": "player_throttle",
                    "label": "Throttle",
                    "kind": "number"
                },
                {
                    "key": "player_time_zone",
                    "label": "Time zone",
                    "kind": "text"
                },
                {
                    "key": "player_data_version",
                    "label": "Version",
                    "kind": "text"
                },
                {
                    "key": "volume",
                    "label": "Volume",
                    "kind": "number"
                },
                {
                    "key": "location_zone.display_string",
                    "label": "Zone",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [],
        "_filled": [
            "player_id",
            "location_zone_player_stream_mode_id",
            "mono",
            "client_did_set_volume",
            "client_did_set_muted",
            "set_volume_contact_id",
            "can_vote",
            "audio_device",
            "can_skip",
            "last_loaded_date",
            "complete_track",
            "can_set_volume"
        ],
        "_unique": []
    },
    "LocationZonePlayerParsedPlaylistTrack": {
        "id": "number",
        "_displayName": "'Location Zone Player Parsed Playlist Track'",
        "_slug": "'location_zone_player_parsed_playlist_track'",
        "created_at": "Date",
        "location_zone_player_id": "number",
        "location_zone_player_parsed_playlist_id": "number",
        "position": "number",
        "track_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_searchable": [
            "id",
            "location_zone_player_id",
            "location_zone_player_parsed_playlist_id",
            "track_id",
            "position",
            "created_at",
            "updated_at"
        ]
    },
    "MusicZoneFolder": {
        "id": "number",
        "_displayName": "'Music Zone Folder'",
        "_slug": "'music_zone_folder'",
        "created_at": "Date",
        "description": "string",
        "location_zones": "LocationZone",
        "name": "string",
        "owner": "User",
        "owner_user_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "description",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "owner": "owner.display_string",
            "location_zones": "location_zones.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": [],
        "_searchable": [
            "id",
            "name",
            "description",
            "owner_user_id",
            "owner",
            "location_zones",
            "created_at",
            "updated_at"
        ],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": []
    },
    "RawDdexTrack": {
        "id": "number",
        "_displayName": "'Ddex Track'",
        "_slug": "'raw_ddex_track'",
        "album_artists": "any[]",
        "album_name": "string",
        "artists": "any[]",
        "audio_file_checksum": "string",
        "audio_file_s3_path": "string",
        "bitrate": "number",
        "catalog_number": "string",
        "commercial_model_type": "any[]",
        "copyright": "number",
        "cover_art_hash": "string",
        "cover_art_s3_path": "string",
        "cover_art_signed_url": "string",
        "cover_art_type": "string",
        "created_at": "Date",
        "duration": "number",
        "ean": "string",
        "excluded_territory_codes": "any[]",
        "genre_name": "string",
        "grid": "string",
        "icpn": "string",
        "isrc": "string",
        "major_record_label_name": "string",
        "message_date": "Date",
        "parental_advisory": "string",
        "publishers": "any[]",
        "raw_ddex_ern_message": "RawDdexErnMessage",
        "raw_ddex_ern_message_id": "number",
        "raw_ddex_party_sender": "RawDdexParty",
        "raw_ddex_party_sender_id": "number",
        "raw_ddex_party_sent_on_behalf_of": "RawDdexParty",
        "raw_ddex_party_sent_on_behalf_of_id": "number",
        "raw_ddex_release_type": "RawDdexReleaseType",
        "raw_ddex_release_type_id": "number",
        "raw_ddex_sound_recording_releases": "RawDdexSoundRecordingRelease",
        "raw_ddex_track_echoprint_state": "RawDdexTrackEchoprintState",
        "raw_ddex_track_fingerprint_matches": "RawDdexTrackFingerprintMatch[]",
        "raw_ddex_track_takedown_status": "RawDdexTrackTakedownStatus",
        "raw_ddex_track_takedown_status_id": "number",
        "record_label_name": "string",
        "release_reference": "string",
        "release_resource_reference": "string",
        "release_type": "string",
        "sub_genre_name": "string",
        "sub_title": "string",
        "territory_codes": "any[]",
        "title": "string",
        "upc": "string",
        "updated_at": "Date",
        "usage": "any[]",
        "validity_period": "any[]",
        "_nullable": [
            "raw_ddex_party_sender_id",
            "raw_ddex_party_sent_on_behalf_of_id",
            "title",
            "isrc",
            "sub_title",
            "artists",
            "record_label_name",
            "major_record_label_name",
            "genre_name",
            "sub_genre_name",
            "duration",
            "copyright",
            "audio_file_s3_path",
            "audio_file_checksum",
            "bitrate",
            "publishers",
            "parental_advisory",
            "cover_art_s3_path",
            "cover_art_signed_url",
            "cover_art_type",
            "cover_art_hash",
            "catalog_number",
            "grid",
            "release_reference",
            "release_resource_reference",
            "commercial_model_type",
            "usage",
            "validity_period",
            "territory_codes",
            "excluded_territory_codes",
            "album_artists",
            "album_name",
            "ean",
            "upc",
            "raw_ddex_track_takedown_status_id",
            "release_type",
            "raw_ddex_release_type_id",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": {
            "raw_ddex_party_sender": "sender",
            "raw_ddex_party_sent_on_behalf_of": "sent_on_behalf_of"
        },
        "_filterFieldMappings": {
            "album_artists": "album_artists.name",
            "artists": "artists.name",
            "sender": "raw_ddex_party_sender_id",
            "sent_on_behalf_of": "raw_ddex_party_sent_on_behalf_of_id"
        },
        "_frontendFields": [],
        "_childrenMappings": [],
        "_searchable": [
            "id",
            "display_string",
            "title",
            "sub_title",
            "artists",
            "record_label_name",
            "major_record_label_name",
            "genre_name",
            "sub_genre_name",
            "raw_ddex_ern_message_id",
            "raw_ddex_party_sender_id",
            "raw_ddex_party_sent_on_behalf_of_id",
            "message_date",
            "audio_file_s3_path",
            "duration",
            "isrc",
            "audio_file_checksum",
            "bitrate",
            "publishers",
            "parental_advisory",
            "cover_art_s3_path",
            "cover_art_signed_url",
            "cover_art_type",
            "cover_art_hash",
            "release_reference",
            "release_resource_reference",
            "commercial_model_type",
            "usage",
            "validity_period",
            "album_artists",
            "album_name",
            "grid",
            "upc",
            "ean",
            "icpn",
            "catalog_number",
            "raw_ddex_track_takedown_status_id",
            "raw_ddex_ern_message",
            "raw_ddex_party_sender",
            "raw_ddex_party_sent_on_behalf_of",
            "raw_ddex_release_type",
            "raw_ddex_track_echoprint_state",
            "raw_ddex_track_takedown_status",
            "release_type",
            "created_at",
            "updated_at",
            "territory_codes",
            "excluded_territory_codes"
        ],
        "_quickSearch": {
            "defaults": [
                "title",
                "artists.name",
                "isrc",
                "album_name"
            ],
            "offered": [
                {
                    "key": "album_name",
                    "label": "Album",
                    "kind": "text"
                },
                {
                    "key": "album_artists.name",
                    "label": "Album artists",
                    "kind": "text"
                },
                {
                    "key": "artists.name",
                    "label": "Artists",
                    "kind": "text"
                },
                {
                    "key": "audio_file_checksum",
                    "label": "Audio file checksum",
                    "kind": "text"
                },
                {
                    "key": "audio_file_s3_path",
                    "label": "Audio file s3 path",
                    "kind": "text"
                },
                {
                    "key": "bitrate",
                    "label": "Bitrate",
                    "kind": "number"
                },
                {
                    "key": "catalog_number",
                    "label": "Catalog number",
                    "kind": "text"
                },
                {
                    "key": "commercial_model_type",
                    "label": "Commercial model type",
                    "kind": "text"
                },
                {
                    "key": "cover_art_hash",
                    "label": "Cover art hash",
                    "kind": "text"
                },
                {
                    "key": "cover_art_s3_path",
                    "label": "Cover art s3 path",
                    "kind": "text"
                },
                {
                    "key": "cover_art_signed_url",
                    "label": "Cover art signed url",
                    "kind": "text"
                },
                {
                    "key": "cover_art_type",
                    "label": "Cover art type",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "ean",
                    "label": "Ean",
                    "kind": "text"
                },
                {
                    "key": "excluded_territory_codes",
                    "label": "Excluded territory codes",
                    "kind": "text"
                },
                {
                    "key": "genre_name",
                    "label": "Genre name",
                    "kind": "text"
                },
                {
                    "key": "grid",
                    "label": "Grid",
                    "kind": "text"
                },
                {
                    "key": "icpn",
                    "label": "Icpn",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "isrc",
                    "label": "ISRC",
                    "kind": "text"
                },
                {
                    "key": "major_record_label_name",
                    "label": "Major record label name",
                    "kind": "text"
                },
                {
                    "key": "parental_advisory",
                    "label": "Parental advisory",
                    "kind": "text"
                },
                {
                    "key": "publishers",
                    "label": "Publishers",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_ern_message.display_string",
                    "label": "Raw ddex ern message",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_ern_message_id",
                    "label": "Raw ddex ern message id",
                    "kind": "number"
                },
                {
                    "key": "raw_ddex_party_sender_id",
                    "label": "Raw ddex party sender id",
                    "kind": "number"
                },
                {
                    "key": "raw_ddex_party_sent_on_behalf_of_id",
                    "label": "Raw ddex party sent on behalf of id",
                    "kind": "number"
                },
                {
                    "key": "raw_ddex_release_type.display_string",
                    "label": "Raw ddex release type",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_track_echoprint_state.display_string",
                    "label": "Raw ddex track echoprint state",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_track_takedown_status.display_string",
                    "label": "Raw ddex track takedown status",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_track_takedown_status_id",
                    "label": "Raw ddex track takedown status id",
                    "kind": "number"
                },
                {
                    "key": "record_label_name",
                    "label": "Record label name",
                    "kind": "text"
                },
                {
                    "key": "release_reference",
                    "label": "Release reference",
                    "kind": "text"
                },
                {
                    "key": "release_resource_reference",
                    "label": "Release resource reference",
                    "kind": "text"
                },
                {
                    "key": "release_type",
                    "label": "Release type",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_party_sender.display_string",
                    "label": "Sender",
                    "kind": "text"
                },
                {
                    "key": "raw_ddex_party_sent_on_behalf_of.display_string",
                    "label": "Sent on behalf of",
                    "kind": "text"
                },
                {
                    "key": "sub_genre_name",
                    "label": "Sub genre name",
                    "kind": "text"
                },
                {
                    "key": "sub_title",
                    "label": "Sub title",
                    "kind": "text"
                },
                {
                    "key": "territory_codes",
                    "label": "Territory codes",
                    "kind": "text"
                },
                {
                    "key": "title",
                    "label": "Title",
                    "kind": "text"
                },
                {
                    "key": "upc",
                    "label": "Upc",
                    "kind": "text"
                },
                {
                    "key": "usage",
                    "label": "Usage",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "raw_ddex_ern_message_id",
            "message_date",
            "title",
            "sub_title",
            "artists",
            "record_label_name",
            "major_record_label_name",
            "genre_name",
            "sub_genre_name",
            "duration",
            "isrc",
            "copyright",
            "audio_file_s3_path",
            "audio_file_checksum",
            "bitrate",
            "publishers",
            "parental_advisory",
            "cover_art_s3_path",
            "cover_art_type",
            "cover_art_hash",
            "release_reference",
            "commercial_model_type",
            "usage",
            "validity_period",
            "album_artists",
            "album_name",
            "grid",
            "icpn",
            "catalog_number",
            "release_type"
        ],
        "_unique": []
    },
    "RecordLabel": {
        "id": "number",
        "_displayName": "'Record Label'",
        "_slug": "'record_label'",
        "albums": "Album[]",
        "categories": "Category",
        "deleted_at": "Date",
        "dpid": "string",
        "is_active": "boolean",
        "isrc_is_required": "boolean",
        "name": "string",
        "parent_record_label": "RecordLabel",
        "parent_record_label_id": "number",
        "sub_record_labels": "RecordLabel[]",
        "tags": "Tag",
        "tracks": "LiveTrack[]",
        "_nullable": [
            "parent_record_label_id",
            "dpid",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "parent_record_label": "parent_record_label.display_string",
            "sub_record_labels": "sub_record_labels.display_string",
            "categories": "categories.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "categories": "category",
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "display_string",
            "name",
            "parent_record_label_id",
            "parent_record_label",
            "dpid",
            "is_active",
            "isrc_is_required",
            "sub_record_labels",
            "categories",
            "tags"
        ],
        "_quickSearch": {
            "defaults": [
                "name",
                "dpid"
            ],
            "offered": [
                {
                    "key": "categories.display_string",
                    "label": "Categories",
                    "kind": "text"
                },
                {
                    "key": "display_string",
                    "label": "Display string",
                    "kind": "text"
                },
                {
                    "key": "dpid",
                    "label": "DPID",
                    "kind": "text"
                },
                {
                    "key": "id",
                    "label": "Id",
                    "kind": "number"
                },
                {
                    "key": "name",
                    "label": "Name",
                    "kind": "text"
                },
                {
                    "key": "parent_record_label.display_string",
                    "label": "Parent record label",
                    "kind": "text"
                },
                {
                    "key": "parent_record_label_id",
                    "label": "Parent record label id",
                    "kind": "number"
                },
                {
                    "key": "sub_record_labels.display_string",
                    "label": "Sub record labels",
                    "kind": "text"
                },
                {
                    "key": "tags.display_string",
                    "label": "Tags",
                    "kind": "text"
                }
            ]
        },
        "_prohibited": [],
        "_filled": [
            "name",
            "parent_record_label_id",
            "is_active",
            "isrc_is_required"
        ],
        "_unique": [
            "name"
        ]
    },
    "Template": {
        "id": "number",
        "_displayName": "'Template'",
        "_slug": "'template'",
        "account": "Account",
        "created_at": "Date",
        "is_archived": "boolean",
        "location": "Location",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "location_zones": "LocationZone[]",
        "name": "string",
        "parts": "Part[]",
        "skip_unique_artists": "boolean",
        "skip_unique_genres": "boolean",
        "tags": "Tag",
        "template_days": "TemplateDay[]",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "location_zone_id",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": {
            "location_zone": "location_zone.display_string",
            "account": "account.display_string",
            "location": "location.display_string",
            "location_zones": "location_zones.display_string",
            "template_days": "template_days.display_string",
            "parts": "parts.display_string",
            "tags": "tags.display_string"
        },
        "_frontendFields": [],
        "_childrenMappings": {
            "tags": "tag"
        },
        "_searchable": [
            "id",
            "name",
            "location_zone_id",
            "created_at",
            "updated_at",
            "skip_unique_genres",
            "skip_unique_artists",
            "is_archived",
            "location_zone",
            "account",
            "location",
            "location_zones",
            "template_days",
            "parts",
            "tags"
        ],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name",
            "location_zone_id",
            "skip_unique_genres",
            "skip_unique_artists",
            "is_archived"
        ],
        "_unique": []
    },
    "SharedSavedView": {
        "id": "number",
        "color": "string",
        "created_at": "Date",
        "definition": "any[]",
        "definition_version": "number",
        "entity": "string",
        "icon": "string",
        "name": "string",
        "share_key": "string",
        "sharedByUser": "User",
        "shared_by_user_id": "number",
        "sourceSavedView": "SavedView",
        "source_saved_view_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "shared_by_user_id",
            "source_saved_view_id",
            "created_at",
            "updated_at",
            "icon",
            "color"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "ShortClipPlaybackType": {
        "id": "number",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "StagedTrack": {
        "id": "number",
        "album_artist_id": "number",
        "album_artist_name": "string",
        "album_id": "number",
        "album_name": "string",
        "album_upc": "string",
        "artist_id": "number",
        "artist_name": "string",
        "bitrate": "number",
        "catalog_code": "string",
        "checksum": "string",
        "checksum_hash_function": "string",
        "code": "string",
        "copyright": "number",
        "created_at": "Date",
        "did_check_lyrics": "boolean",
        "downloaded_as_file_name": "string",
        "duplicate_track_ids": "string",
        "duration": "number",
        "error_text": "string",
        "fade_in_duration": "number",
        "fade_in_start": "number",
        "fade_out_duration": "number",
        "fade_out_start": "number",
        "file_location": "string",
        "fingerprint": "string",
        "fingerprint_code_version": "string",
        "fingerprint_duration": "number",
        "fingerprint_offset": "number",
        "genre_id": "number",
        "genre_name": "string",
        "is_archived": "boolean",
        "is_conflicted": "boolean",
        "is_error": "boolean",
        "is_in_use": "number",
        "is_ready_for_processing": "boolean",
        "is_sound_exchange": "boolean",
        "isrc": "string",
        "lyrics": "TrackLyrics",
        "lyrics_check_status_id": "number",
        "lyrics_check_status_updated_at": "Date",
        "lyrics_check_status_updated_by_user_id": "number",
        "name": "string",
        "normalized_level": "number",
        "original_duration": "number",
        "parental_advisory_type_id": "number",
        "performance_rights_organizations_raw": "string",
        "process_user_id": "number",
        "publishers_raw": "string",
        "record_label_id": "number",
        "record_label_name": "string",
        "region": "string",
        "remix_name": "string",
        "replace_track_id": "number",
        "requested_for_location_zone_id": "number",
        "requested_for_user_id": "number",
        "review_1_done": "boolean",
        "review_2_done": "boolean",
        "review_3_done": "boolean",
        "staged_track_parental_advisory_type_id": "number",
        "staged_track_process_type_id": "number",
        "staged_track_processing_state_id": "number",
        "staged_track_source_id": "number",
        "tags": "Tag",
        "updated_at": "Date",
        "upload_monitor_job_id": "number",
        "upload_user_id": "number",
        "uploaded_date": "Date",
        "_nullable": [
            "parental_advisory_type_id",
            "upload_monitor_job_id",
            "upload_user_id",
            "process_user_id",
            "requested_for_user_id",
            "requested_for_location_zone_id",
            "duplicate_track_ids",
            "replace_track_id",
            "artist_id",
            "album_id",
            "record_label_id",
            "genre_id",
            "name",
            "is_conflicted",
            "artist_name",
            "record_label_name",
            "album_name",
            "album_upc",
            "code",
            "original_duration",
            "duration",
            "copyright",
            "publishers_raw",
            "performance_rights_organizations_raw",
            "region",
            "isrc",
            "file_location",
            "remix_name",
            "uploaded_date",
            "genre_name",
            "fingerprint",
            "fingerprint_code_version",
            "fingerprint_offset",
            "fingerprint_duration",
            "checksum",
            "checksum_hash_function",
            "error_text",
            "created_at",
            "updated_at",
            "did_check_lyrics",
            "lyrics_check_status_updated_at",
            "lyrics_check_status_updated_by_user_id",
            "is_ready_for_processing",
            "downloaded_as_file_name",
            "catalog_code",
            "review_1_done",
            "review_2_done",
            "review_3_done",
            "is_sound_exchange",
            "album_artist_id",
            "album_artist_name",
            "bitrate"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "StagedTrackProcessType": {
        "id": "number",
        "created_at": "Date",
        "name": "string",
        "updated_at": "Date",
        "_nullable": [
            "name",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "StagedTrackSource": {
        "id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "State": {
        "id": "number",
        "abbreviation": "string",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "abbreviation"
        ],
        "_unique": [
            "name",
            "abbreviation"
        ]
    },
    "StreamMode": {
        "id": "number",
        "name": "string",
        "players": "Player[]",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "Tag": {
        "id": "number",
        "child_tags": "Tag[]",
        "created_at": "Date",
        "default_exclude": "boolean",
        "is_artist_tag": "boolean",
        "is_creative": "boolean",
        "is_header_tag": "boolean",
        "is_track_user_tag": "boolean",
        "name": "string",
        "parent_tag": "Tag",
        "parent_tag_id": "number",
        "position": "number",
        "track_tag": "boolean",
        "updated_at": "Date",
        "vault_tag": "boolean",
        "_nullable": [
            "created_at",
            "parent_tag_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "Taggable": {
        "id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "tag": "Tag",
        "tag_id": "number",
        "taggable": "Taggable",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "user_id",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "f_id",
            "f_type",
            "tag_id",
            "user_id"
        ],
        "_unique": []
    },
    "TemplateDay": {
        "id": "number",
        "created_at": "Date",
        "day": "Day",
        "day_id": "number",
        "parts": "Part[]",
        "start_time": "string",
        "template": "Template",
        "template_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "start_time",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "template_id",
            "day_id",
            "start_time"
        ],
        "_unique": []
    },
    "TemplateDayInsert": {
        "id": "number",
        "created_at": "Date",
        "end_time": "string",
        "insert": "Insert",
        "insert_id": "number",
        "priority": "number",
        "start_time": "string",
        "template_day": "TemplateDay",
        "template_day_id": "number",
        "updated_at": "Date",
        "_nullable": [
            "start_time",
            "end_time",
            "created_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [
            "created_at",
            "updated_at"
        ],
        "_filled": [
            "insert_id",
            "template_day_id",
            "start_time",
            "end_time",
            "priority"
        ],
        "_unique": []
    },
    "TimeZone": {
        "id": "number",
        "abbreviation": "string",
        "dst_abbreviation": "string",
        "iana_name": "string",
        "is_dst_aware": "boolean",
        "name": "string",
        "notes": "string",
        "offset": "number",
        "_nullable": [
            "name",
            "iana_name",
            "offset",
            "abbreviation",
            "dst_abbreviation",
            "notes"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "is_dst_aware",
            "offset",
            "abbreviation",
            "dst_abbreviation"
        ],
        "_unique": [
            "name",
            "iana_name",
            "abbreviation",
            "dst_abbreviation"
        ]
    },
    "TrackLyrics": {
        "id": "number",
        "created_at": "Date",
        "f_id": "number",
        "f_type": "string",
        "fetched_artist": "string",
        "fetched_title": "string",
        "language": "string",
        "lyrics_body": "string",
        "lyrics_fetch_completed_generation": "number",
        "lyrics_fetch_generation": "number",
        "lyrics_fetch_job_log_partition_key": "string",
        "lyrics_fetch_last_job_log": "string",
        "source_name": "string",
        "source_reference": "string",
        "translation_links": "any[]",
        "updated_at": "Date",
        "_nullable": [
            "lyrics_body",
            "language",
            "source_name",
            "source_reference",
            "fetched_title",
            "fetched_artist",
            "translation_links",
            "lyrics_fetch_job_log_partition_key",
            "lyrics_fetch_last_job_log",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "TrackMatchStatus": {
        "id": "number",
        "name": "string",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": [
            "name"
        ]
    },
    "TrackStreamType": {
        "id": "number",
        "live_tracks": "LiveTrack[]",
        "name": "string",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "User": {
        "id": "number",
        "api_endpoint_id": "number",
        "app_version": "string",
        "clients_only": "boolean",
        "created_at": "Date",
        "crypted_password": "string",
        "deleted_at": "Date",
        "email": "string",
        "email_verified_at": "Date",
        "first_name": "string",
        "group_id": "number",
        "gvdev_slack_code": "string",
        "gvdev_slack_id": "string",
        "is_accountant": "boolean",
        "is_developer": "boolean",
        "is_human": "boolean",
        "is_onboarder": "boolean",
        "is_stylist": "boolean",
        "is_tester": "boolean",
        "is_tpg_user": "boolean",
        "last_crud_message_id": "number",
        "last_poll": "number",
        "logged_in_mac": "string",
        "login": "string",
        "modelPermissions": "UserModelPermission[]",
        "name": "string",
        "os_version": "string",
        "password": "string",
        "remember_token": "string",
        "remember_token_expires_at": "Date",
        "reset_storage_file": "boolean",
        "should_send_debug_email": "boolean",
        "show_in_access_view": "boolean",
        "sillc_slack_code": "string",
        "sillc_slack_id": "string",
        "time_zone_id": "number",
        "time_zone_name": "string",
        "updated_at": "Date",
        "zdesktop_mac": "string",
        "zlaptop_mac": "string",
        "zother_mac": "string",
        "_nullable": [
            "remember_token",
            "crypted_password",
            "remember_token_expires_at",
            "last_poll",
            "created_at",
            "app_version",
            "zdesktop_mac",
            "zlaptop_mac",
            "zother_mac",
            "time_zone_name",
            "time_zone_id",
            "last_crud_message_id",
            "logged_in_mac",
            "sillc_slack_id",
            "sillc_slack_code",
            "gvdev_slack_id",
            "gvdev_slack_code",
            "os_version",
            "email_verified_at",
            "deleted_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "UserModelPermission": {
        "id": "number",
        "can_create": "boolean",
        "can_delete": "boolean",
        "can_update": "boolean",
        "can_view": "boolean",
        "user": "User",
        "user_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "UserPageGrant": {
        "id": "number",
        "page_definition": "PageDefinition",
        "user": "User",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "VoteReason": {
        "id": "number",
        "name": "string",
        "overrideType": "OverrideType",
        "override_type_id": "number",
        "position": "number",
        "voteType": "VoteType",
        "vote_type_id": "number",
        "_nullable": [
            "position",
            "vote_type_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name",
            "override_type_id"
        ],
        "_unique": []
    },
    "VoteType": {
        "id": "number",
        "name": "string",
        "voteReasons": "VoteReason[]",
        "_nullable": [
            "name"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [
            "name"
        ],
        "_unique": []
    },
    "Worklist": {
        "id": "number",
        "created_at": "Date",
        "location_zone_custom_playlists": "LocationZoneCustomPlaylist",
        "location_zones": "LocationZone",
        "music_zone_folders": "MusicZoneFolder",
        "name": "string",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "name",
            "created_at",
            "updated_at"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": [],
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "Zp": {
        "id": "number",
        "created_at": "Date",
        "delimited_bucket_ids": "string",
        "delimited_track_codes": "string",
        "delimited_track_details": "string",
        "delimited_track_ids": "string",
        "location_zone_id": "number",
        "play_date_time": "Date",
        "playlist_generation_attempt_id": "number",
        "success": "boolean",
        "updated_at": "Date",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "ZpgaLog": {
        "id": "number",
        "created_at": "Date",
        "message": "string",
        "playlist_generation_attempt_id": "number",
        "_nullable": [],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "Zt": {
        "id": "number",
        "bucket": "Bucket",
        "bucket_id": "number",
        "created_at": "Date",
        "duration": "number",
        "location_zone": "LocationZone",
        "location_zone_id": "number",
        "track": "LiveTrack",
        "track_id": "number",
        "updated_at": "Date",
        "user": "User",
        "user_id": "number",
        "_nullable": [
            "location_zone_id",
            "duration",
            "created_at",
            "user_id"
        ],
        "_columnNameMappings": [],
        "_filterFieldMappings": [],
        "_frontendFields": [],
        "_childrenMappings": []
    },
    "AssignNewZonePlayer": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "FetchLiveTrackLyrics": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "ImportSharedSavedView": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "LiveTrackActionBulkCreate": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "LocationZonePlayerCommandIssue": {
        "_prohibited": [],
        "_filled": [
            "command"
        ],
        "_unique": []
    },
    "ProfileUpdate": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "Search": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "UpdateLiveTrackLyrics": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "UserPagePermission": {
        "_prohibited": [],
        "_filled": [],
        "_unique": []
    },
    "_constants": {
        "ONLINE_WITHIN_MINUTES": 5,
        "QUICK_SEARCH_ACCENT_VARIANTS": {
            "a": "a\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u0101\u0103\u0105",
            "e": "e\u00e8\u00e9\u00ea\u00eb\u0113\u0117\u0119",
            "i": "i\u00ec\u00ed\u00ee\u00ef\u012b\u012f",
            "o": "o\u00f2\u00f3\u00f4\u00f5\u00f6\u014d\u0151",
            "u": "u\u00f9\u00fa\u00fb\u00fc\u016b\u016f",
            "c": "c\u00e7\u0107\u010d",
            "n": "n\u00f1\u0144",
            "s": "s\u015b\u0161",
            "y": "y\u00fd\u00ff"
        }
    }
}